"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getGenerateFunctionsForEmbed = getGenerateFunctionsForEmbed;
exports.getUtils = getUtils;
var _regeneratorRuntime2 = _interopRequireDefault(require("@babel/runtime/helpers/regeneratorRuntime"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _construct2 = _interopRequireDefault(require("@babel/runtime/helpers/construct"));
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var TWEEN = _interopRequireWildcard(require("@tweenjs/tween.js"));
var _getRandomFunctions3 = _interopRequireDefault(require("./getRandomFunctions"));
var _getGenerateFunctions3 = _interopRequireDefault(require("./getGenerateFunctions"));
var _getDefaults2 = _interopRequireDefault(require("./getDefaults"));
var _getAddObjectsFunctions = _interopRequireDefault(require("./getAddObjectsFunctions"));
var _selectObject = _interopRequireDefault(require("./selectObject"));
var _getAnimationFunctions = _interopRequireDefault(require("./getAnimationFunctions"));
var _getAddLayers2 = _interopRequireDefault(require("./getAddLayers"));
var _getAddSaveFunction2 = _interopRequireDefault(require("./getAddSaveFunction"));
var _canvasTextRenderer2 = _interopRequireDefault(require("./canvasTextRenderer"));
var _excluded = ["key"],
  _excluded2 = ["nextState"];
function getGenerateFunctionsForEmbed(_ref) {
  var randomFunction = _ref.randomFunction;
  var _getRandomFunctions = (0, _getRandomFunctions3["default"])({
      randomFunction: randomFunction
    }),
    shuffleArray = _getRandomFunctions.shuffleArray,
    getRandomInt = _getRandomFunctions.getRandomInt,
    generatePropsArray = _getRandomFunctions.generatePropsArray;
  var _getGenerateFunctions = (0, _getGenerateFunctions3["default"])({
      shuffleArray: shuffleArray,
      getRandomInt: getRandomInt,
      generatePropsArray: generatePropsArray
    }),
    generateRenderProps = _getGenerateFunctions.generateRenderProps,
    generateCompositions = _getGenerateFunctions.generateCompositions;
  return {
    generateRenderProps: generateRenderProps,
    generateCompositions: generateCompositions
  };
}
function getUtils(_ref2) {
  var THREE = _ref2.THREE,
    randomFunction = _ref2.randomFunction,
    params = _ref2.params;
  var _getRandomFunctions2 = (0, _getRandomFunctions3["default"])({
      randomFunction: randomFunction
    }),
    shuffleArray = _getRandomFunctions2.shuffleArray,
    getRandomInt = _getRandomFunctions2.getRandomInt,
    generatePropsArray = _getRandomFunctions2.generatePropsArray,
    getThreeJsInternalRandomFunctions = _getRandomFunctions2.getThreeJsInternalRandomFunctions;
  var _getGenerateFunctions2 = (0, _getGenerateFunctions3["default"])({
      shuffleArray: shuffleArray,
      getRandomInt: getRandomInt,
      generatePropsArray: generatePropsArray
    }),
    generateRenderProps = _getGenerateFunctions2.generateRenderProps,
    generateCompositions = _getGenerateFunctions2.generateCompositions;
  var _getDefaults = (0, _getDefaults2["default"])(),
    defaultMaterialProps = _getDefaults.defaultMaterialProps,
    defaultCameraPosition = _getDefaults.defaultCameraPosition,
    defaultCameraUp = _getDefaults.defaultCameraUp,
    defaultCameraTarget = _getDefaults.defaultCameraTarget,
    defaultDimensions = _getDefaults.defaultDimensions,
    getDefaultObjectsPosition = _getDefaults.getDefaultObjectsPosition,
    defaultControlsProps = _getDefaults.defaultControlsProps,
    defaultLightParams = _getDefaults.defaultLightParams;
  var _getSelectObjectFunct = (0, _selectObject["default"])({
      THREE: THREE
    }),
    selectObject = _getSelectObjectFunct.selectObject,
    setOpacity = _getSelectObjectFunct.setOpacity,
    resetOpacity = _getSelectObjectFunct.resetOpacity;
  var _getAddObjectsFunctio = (0, _getAddObjectsFunctions["default"])({
      THREE: THREE,
      defaultMaterialProps: defaultMaterialProps,
      getThreeJsInternalRandomFunctions: getThreeJsInternalRandomFunctions,
      setOpacity: setOpacity
    }),
    addObjects = _getAddObjectsFunctio.addObjects,
    addObjectsWithoutAnimation = _getAddObjectsFunctio.addObjectsWithoutAnimation,
    addToLayers = _getAddObjectsFunctio.addToLayers,
    preloader = _getAddObjectsFunctio.preloader;
  var _getAddLayers = (0, _getAddLayers2["default"])({
      THREE: THREE,
      getThreeJsInternalRandomFunctions: getThreeJsInternalRandomFunctions
    }),
    setBackground = _getAddLayers.setBackground,
    setCanvasBackground = _getAddLayers.setCanvasBackground,
    applyPostFilters = _getAddLayers.applyPostFilters,
    getCameraProps = _getAddLayers.getCameraProps,
    addCameraAndRenderer = _getAddLayers.addCameraAndRenderer;
  var _getAnimationFunction = (0, _getAnimationFunctions["default"])({
      THREE: THREE,
      getCameraProps: getCameraProps
    }),
    objectMove = _getAnimationFunction.objectMove,
    objectsMove = _getAnimationFunction.objectsMove,
    getNCameraPosSpherical = _getAnimationFunction.getNCameraPosSpherical,
    cameraMoveByControls = _getAnimationFunction.cameraMoveByControls,
    cameraMoveToPosition = _getAnimationFunction.cameraMoveToPosition,
    startAnimation = _getAnimationFunction.startAnimation;
  var _getAddSaveFunction = (0, _getAddSaveFunction2["default"])(),
    addSaveFunction = _getAddSaveFunction.addSaveFunction;
  function setLast(_ref3) {
    var threeJs = _ref3.threeJs,
      key = _ref3.key;
    if (!threeJs.last) {
      threeJs.last = {};
    }
    threeJs.last[key] = threeJs[key];
  }
  function updateSplitScreenData(_ref4) {
    var threeJs = _ref4.threeJs;
    var currentComposition = threeJs.currentComposition;
    setLast({
      threeJs: threeJs,
      key: "splitScreenData"
    });
    threeJs.splitScreenData = currentComposition.splitScreen ? currentComposition.splitScreen : null;
  }
  function threeJsObjectUpdateRandomVariables(_ref5) {
    var threeJs = _ref5.threeJs;
    threeJs.randomVariables = threeJs.currentComposition.randomVariables;
  }
  function threeJsObjectUpdateBackground(_ref6) {
    var threeJs = _ref6.threeJs;
    var currentComposition = threeJs.currentComposition;
    threeJs.background = currentComposition.background || "#eeac56";
    threeJs.canvasBackground = currentComposition.canvasBackground;
    threeJs.canvasFullBackground = currentComposition.canvasFullBackground;
  }
  function threeJsObjectUpdateLights(_ref7) {
    var _currentComposition$a;
    var threeJs = _ref7.threeJs;
    var currentComposition = threeJs.currentComposition;
    threeJs.lights = currentComposition !== null && currentComposition !== void 0 && currentComposition.lights ? (0, _toConsumableArray2["default"])(currentComposition.lights.map(function (light) {
      return (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, defaultLightParams), light), {}, {
        props: light.props || defaultLightParams.props
      });
    })) : [];
    threeJs.ambientLight = {
      props: (currentComposition === null || currentComposition === void 0 ? void 0 : (_currentComposition$a = currentComposition.ambientLight) === null || _currentComposition$a === void 0 ? void 0 : _currentComposition$a.props) || [0xffffff, 1]
    };
  }
  function threeJsObjectUpdateControlsProps(_ref8) {
    var _currentComposition$c;
    var threeJs = _ref8.threeJs;
    var currentComposition = threeJs.currentComposition;
    threeJs.controlsProps = (0, _objectSpread2["default"])({}, Object.keys(defaultControlsProps).reduce(function (o, key) {
      o[key] = currentComposition !== null && currentComposition !== void 0 && currentComposition.controlsProps && typeof currentComposition.controlsProps[key] === "number" ? currentComposition.controlsProps[key] : defaultControlsProps[key];
      return o;
    }, {}));
    if (currentComposition !== null && currentComposition !== void 0 && (_currentComposition$c = currentComposition.controlsProps) !== null && _currentComposition$c !== void 0 && _currentComposition$c.enableZoom) {
      threeJs.controlsProps.enableZoom = true;
    }
    if (currentComposition !== null && currentComposition !== void 0 && currentComposition.controlsProps && (currentComposition === null || currentComposition === void 0 ? void 0 : currentComposition.controlsProps.minZoom) >= 0) {
      threeJs.controlsProps.minZoom = currentComposition.controlsProps.minZoom;
    }
    if (currentComposition !== null && currentComposition !== void 0 && currentComposition.controlsProps && (currentComposition === null || currentComposition === void 0 ? void 0 : currentComposition.controlsProps.maxZoom) >= 0) {
      threeJs.controlsProps.maxZoom = currentComposition.controlsProps.maxZoom;
    }
  }
  function threeJsObjectUpdateCameraData(_ref9) {
    var threeJs = _ref9.threeJs,
      cameraZoom = _ref9.cameraZoom;
    setLast({
      threeJs: threeJs,
      key: "cameraUp"
    });
    setLast({
      threeJs: threeJs,
      key: "cameraPosition"
    });
    setLast({
      threeJs: threeJs,
      key: "defaultTarget"
    });
    setLast({
      threeJs: threeJs,
      key: "cameraZoom"
    });
    var currentComposition = threeJs.currentComposition;
    threeJs.cameraUp = (0, _objectSpread2["default"])({}, currentComposition.cameraUp && typeof currentComposition.cameraUp.x === "number" ? currentComposition.cameraUp : defaultCameraUp);
    threeJs.cameraPosition = (0, _objectSpread2["default"])({}, currentComposition.cameraPosition && typeof currentComposition.cameraPosition.x === "number" ? currentComposition.cameraPosition : defaultCameraPosition);
    threeJs.defaultTarget = (0, _construct2["default"])(THREE.Vector3, (0, _toConsumableArray2["default"])(Object.values(currentComposition.cameraTarget && typeof currentComposition.cameraTarget.x === "number" ? currentComposition.cameraTarget : defaultCameraTarget)));
    if (!threeJs.target) {
      threeJs.target = new THREE.Vector3(threeJs.defaultTarget.x, threeJs.defaultTarget.y, threeJs.defaultTarget.z);
    }
    threeJs.cameraZoom = typeof currentComposition.cameraZoom === "number" ? currentComposition.cameraZoom : typeof cameraZoom === "number" ? cameraZoom : 1;
  }
  function threeJsObjectUpdatePostFilters(_ref10) {
    var threeJs = _ref10.threeJs;
    var currentComposition = threeJs.currentComposition;
    threeJs.postFilters = currentComposition.postFilters;
  }
  function threeJsObjectUpdateDimensions(_ref11) {
    var _currentComposition$d, _currentComposition$d2, _currentComposition$d3;
    var threeJs = _ref11.threeJs;
    var currentComposition = threeJs.currentComposition;
    var newDimensions = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, defaultDimensions), (_currentComposition$d = currentComposition.dimensions) !== null && _currentComposition$d !== void 0 && _currentComposition$d.dimensions ? currentComposition.dimensions.dimensions.reduce(function (r, dim) {
      var key = dim.key,
        rest = (0, _objectWithoutProperties2["default"])(dim, _excluded);
      r[key] = (0, _objectSpread2["default"])({}, rest);
      return r;
    }, {}) : {});
    threeJs.dimensions = Object.keys(newDimensions).reduce(function (r, key) {
      if (newDimensions[key] && newDimensions[key].width && newDimensions[key].height) {
        r[key] = newDimensions[key];
      }
      return r;
    }, {});
    threeJs.defaultDimension = (_currentComposition$d2 = currentComposition.dimensions) !== null && _currentComposition$d2 !== void 0 && _currentComposition$d2.defaultDimension ? (_currentComposition$d3 = currentComposition.dimensions) === null || _currentComposition$d3 === void 0 ? void 0 : _currentComposition$d3.defaultDimension : Object.keys(threeJs.dimensions)[0];
  }
  function threeJsObjectSetAnimationProps(_ref12) {
    var threeJs = _ref12.threeJs;
    var currentComposition = threeJs.currentComposition;
    var animationProps = (currentComposition === null || currentComposition === void 0 ? void 0 : currentComposition.animationProps) || {};
    var _animationProps$addOb = animationProps.addObjectsAnimationType,
      addObjectsAnimationType = _animationProps$addOb === void 0 ? "default" : _animationProps$addOb,
      _animationProps$addOb2 = animationProps.addObjectsAnimationTime,
      addObjectsAnimationTime = _animationProps$addOb2 === void 0 ? [600, 1400] : _animationProps$addOb2,
      _animationProps$addOb3 = animationProps.addObjectsDefaultGoal,
      addObjectsDefaultGoal = _animationProps$addOb3 === void 0 ? 40 : _animationProps$addOb3,
      _animationProps$addOb4 = animationProps.addObjectsFromCurrentToNextGoal,
      addObjectsFromCurrentToNextGoal = _animationProps$addOb4 === void 0 ? 16 : _animationProps$addOb4,
      _animationProps$camer = animationProps.cameraMoveTime,
      cameraMoveTime = _animationProps$camer === void 0 ? 900 : _animationProps$camer,
      _animationProps$waitT = animationProps.waitTimeBetweenAnimations,
      waitTimeBetweenAnimations = _animationProps$waitT === void 0 ? 250 : _animationProps$waitT,
      _animationProps$waitT2 = animationProps.waitTimeBeforeAnimation,
      waitTimeBeforeAnimation = _animationProps$waitT2 === void 0 ? 250 : _animationProps$waitT2,
      _animationProps$waitT3 = animationProps.waitTimeBeforeAnimation2,
      waitTimeBeforeAnimation2 = _animationProps$waitT3 === void 0 ? 250 : _animationProps$waitT3,
      _animationProps$waitT4 = animationProps.waitTimeFinalEnd,
      waitTimeFinalEnd = _animationProps$waitT4 === void 0 ? 1000 : _animationProps$waitT4,
      _animationProps$easin = animationProps.easingFunction,
      easingFunction = _animationProps$easin === void 0 ? "Quadratic" : _animationProps$easin,
      _animationProps$easin2 = animationProps.easingType,
      easingType = _animationProps$easin2 === void 0 ? "InOut" : _animationProps$easin2,
      _animationProps$camer2 = animationProps.cameraEasingFunction,
      cameraEasingFunction = _animationProps$camer2 === void 0 ? "Quadratic" : _animationProps$camer2,
      _animationProps$camer3 = animationProps.cameraEasingType,
      cameraEasingType = _animationProps$camer3 === void 0 ? "InOut" : _animationProps$camer3,
      _animationProps$objec = animationProps.objectsEasingFunction,
      objectsEasingFunction = _animationProps$objec === void 0 ? "Quadratic" : _animationProps$objec,
      _animationProps$objec2 = animationProps.objectsEasingType,
      objectsEasingType = _animationProps$objec2 === void 0 ? "InOut" : _animationProps$objec2;
    var validAddObjectsAnimationTime = addObjectsAnimationTime.length === 2 && addObjectsAnimationTime[0] > 0 && addObjectsAnimationTime[1] > 0 ? addObjectsAnimationTime : [600, 1400];
    threeJs.animationProps = {
      addObjectsAnimationType: addObjectsAnimationType,
      addObjectsAnimationTime: validAddObjectsAnimationTime,
      addObjectsDefaultGoal: addObjectsDefaultGoal,
      addObjectsFromCurrentToNextGoal: addObjectsFromCurrentToNextGoal,
      cameraMoveTime: cameraMoveTime,
      waitTimeBetweenAnimations: waitTimeBetweenAnimations,
      waitTimeBeforeAnimation: waitTimeBeforeAnimation,
      waitTimeBeforeAnimation2: waitTimeBeforeAnimation2,
      waitTimeFinalEnd: waitTimeFinalEnd,
      easingFunction: easingFunction,
      easingType: easingType,
      cameraEasingFunction: cameraEasingFunction,
      cameraEasingType: cameraEasingType,
      objectsEasingFunction: objectsEasingFunction,
      objectsEasingType: objectsEasingType
    };
  }
  function updateThreeJsObject(_ref13) {
    var threeJs = _ref13.threeJs,
      editor = _ref13.editor,
      cameraZoom = _ref13.cameraZoom;
    updateSplitScreenData({
      threeJs: threeJs
    });
    threeJsObjectUpdateRandomVariables({
      threeJs: threeJs
    });
    threeJsObjectUpdateCameraData({
      threeJs: threeJs,
      cameraZoom: cameraZoom
    });
    threeJsObjectUpdateBackground({
      threeJs: threeJs
    });
    threeJsObjectUpdatePostFilters({
      threeJs: threeJs
    });
    threeJsObjectUpdateDimensions({
      threeJs: threeJs
    });
    threeJsObjectUpdateControlsProps({
      threeJs: threeJs,
      editor: editor
    });
    threeJsObjectUpdateLights({
      threeJs: threeJs,
      editor: editor
    });
    threeJsObjectSetAnimationProps({
      threeJs: threeJs
    });
  }
  function setControls(_ref14) {
    var threeJs = _ref14.threeJs,
      editor = _ref14.editor;
    if (!editor) {
      threeJs.controls.minPolarAngle = threeJs.controlsProps.minPolarAngle;
      threeJs.controls.maxPolarAngle = threeJs.controlsProps.maxPolarAngle;
      threeJs.controls.minAzimuthAngle = threeJs.controlsProps.minAzimuthAngle;
      threeJs.controls.maxAzimuthAngle = threeJs.controlsProps.maxAzimuthAngle;
      if (threeJs.controlsProps.enableZoom) {
        threeJs.controls.noPan = undefined;
        threeJs.controls.enablePan = true;
        threeJs.controls.enableZoom = true;
        threeJs.controls.noZoom = undefined;
        if (threeJs.controlsProps.minZoom) {
          threeJs.controls.minZoom = threeJs.controlsProps.minZoom;
        }
        if (threeJs.controlsProps.maxZoom) {
          threeJs.controls.maxZoom = threeJs.controlsProps.maxZoom;
        }
      } else {
        threeJs.controls.noPan = true;
        threeJs.controls.enablePan = false;
        threeJs.controls.enableZoom = false;
        threeJs.controls.noZoom = true;
      }
    }
  }
  function updateLights(_ref15) {
    var _threeJs$lightsOnScen, _threeJs$lightsHelper;
    var threeJs = _ref15.threeJs,
      editor = _ref15.editor;
    (_threeJs$lightsOnScen = threeJs.lightsOnScene).remove.apply(_threeJs$lightsOnScen, (0, _toConsumableArray2["default"])(threeJs.lightsOnScene.children));
    (_threeJs$lightsHelper = threeJs.lightsHelpers).remove.apply(_threeJs$lightsHelper, (0, _toConsumableArray2["default"])(threeJs.lightsHelpers.children));
    var ambientLight = (0, _construct2["default"])(THREE.AmbientLight, (0, _toConsumableArray2["default"])(threeJs.ambientLight.props));
    threeJs.lightsOnScene.add(ambientLight);
    addToLayers(ambientLight);
    threeJs.lights.forEach(function (light) {
      var _light1$target$positi, _light$target, _threeJs$shadow;
      var light1 = light.type === "Point" ? (0, _construct2["default"])(THREE.PointLight, (0, _toConsumableArray2["default"])(light.props || [])) : light.type === "Directional" ? (0, _construct2["default"])(THREE.DirectionalLight, (0, _toConsumableArray2["default"])(light.props || [])) : (0, _construct2["default"])(THREE.SpotLight, (0, _toConsumableArray2["default"])(light.props || []));
      light1.target = new THREE.Object3D();
      light1.position.set(light.x, light.y, light.z);
      (_light1$target$positi = light1.target.position).set.apply(_light1$target$positi, (0, _toConsumableArray2["default"])(typeof ((_light$target = light.target) === null || _light$target === void 0 ? void 0 : _light$target.x) === "number" ? [light.target.x, light.target.y, light.target.z] : [0, 0, 0]));
      if ((_threeJs$shadow = threeJs.shadow) !== null && _threeJs$shadow !== void 0 && _threeJs$shadow.enable) {
        light1.castShadow = true;
      }
      if (light1.shadow) {
        var _threeJs$renderer, _threeJs$renderer$sha;
        var _threeJs$getWidthAndH = threeJs.getWidthAndHeight(0),
          width = _threeJs$getWidthAndH.width,
          height = _threeJs$getWidthAndH.height;
        light1.shadow.camera.aspect = width / height;
        light1.shadow.camera.left = -threeJs.cameraD * light1.shadow.camera.aspect;
        light1.shadow.camera.right = threeJs.cameraD * light1.shadow.camera.aspect;
        light1.shadow.camera.top = threeJs.cameraD;
        light1.shadow.camera.bottom = -threeJs.cameraD;
        if (light1.shadow.camera.type === "OrthographicCamera") {
          light1.shadow.camera.near = -10000;
          light1.shadow.camera.far = 10000;
        } else {
          light1.shadow.camera.near = 0.1;
          light1.shadow.camera.far = 1000;
        }
        light1.shadow.mapSize.width = 1024;
        light1.shadow.mapSize.height = 1024;
        light1.shadow.bias = -0.000001;
        light1.shadow.radius = 2;
        if (((_threeJs$renderer = threeJs.renderer) === null || _threeJs$renderer === void 0 ? void 0 : (_threeJs$renderer$sha = _threeJs$renderer.shadowMap) === null || _threeJs$renderer$sha === void 0 ? void 0 : _threeJs$renderer$sha.type) === THREE.VSMShadowMap) {
          light1.shadow.camera.near = 0.1;
          light1.shadow.camera.far = 500;
          light1.shadow.radius = 2;
        }
      }
      threeJs.lightsOnScene.add(light1.target);
      threeJs.lightsOnScene.add(light1);
      addToLayers(light1);
      if (editor) {
        var lightHelper = light.type === "Point" ? new THREE.PointLightHelper(light1, 2) : light.type === "Directional" ? new THREE.DirectionalLightHelper(light1, 2) : new THREE.SpotLightHelper(light1);
        lightHelper.position.set(light1.position.x, light1.position.y, light1.position.z);
        threeJs.lightsHelpers.add(lightHelper);
        addToLayers(lightHelper);
        lightHelper.userData.onRender = function () {
          lightHelper.update();
        };
      }
    });
  }
  function updateBackground(_ref16) {
    var threeJs = _ref16.threeJs;
    setBackground(threeJs);
    setCanvasBackground({
      threeJs: threeJs
    });
  }
  function updatePostFilters(_ref17) {
    var threeJs = _ref17.threeJs;
    applyPostFilters({
      threeJs: threeJs
    });
  }
  function updateCalloutNotations(_ref18) {
    var _threeJs$splitScreenD, _threeJs$splitScreenD2, _threeJs$splitScreenD3, _threeJs$splitScreenD4, _threeJs$splitScreenD5, _threeJs$editLinesDat, _threeJs$splitScreenD6, _threeJs$splitScreenD7, _threeJs$splitScreenD8, _threeJs$splitScreenD9, _threeJs$splitScreenD10, _threeJs$calloutNotat;
    var threeJs = _ref18.threeJs;
    var currentComposition = threeJs.currentComposition;
    threeJs.calloutNotationsData = currentComposition.calloutNotations ? currentComposition.calloutNotations : null;
    threeJs.editLinesData = currentComposition.editLines ? currentComposition.editLines : null;
    threeJs.showEditLines = (_threeJs$splitScreenD = threeJs.splitScreenData) !== null && _threeJs$splitScreenD !== void 0 && _threeJs$splitScreenD.startWithSplitScreen && (_threeJs$splitScreenD2 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD2 !== void 0 && _threeJs$splitScreenD2.renderersData && (_threeJs$splitScreenD3 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD3 !== void 0 && _threeJs$splitScreenD3.renderersData["0"] && (_threeJs$splitScreenD4 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD4 !== void 0 && _threeJs$splitScreenD4.renderersData["0"].editLines ? (_threeJs$splitScreenD5 = threeJs.splitScreenData) === null || _threeJs$splitScreenD5 === void 0 ? void 0 : _threeJs$splitScreenD5.renderersData["0"].editLines.show : (_threeJs$editLinesDat = threeJs.editLinesData) === null || _threeJs$editLinesDat === void 0 ? void 0 : _threeJs$editLinesDat.show;
    threeJs.showCalloutNotations = (_threeJs$splitScreenD6 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD6 !== void 0 && _threeJs$splitScreenD6.startWithSplitScreen && (_threeJs$splitScreenD7 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD7 !== void 0 && _threeJs$splitScreenD7.renderersData && (_threeJs$splitScreenD8 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD8 !== void 0 && _threeJs$splitScreenD8.renderersData["0"] && (_threeJs$splitScreenD9 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD9 !== void 0 && _threeJs$splitScreenD9.renderersData["0"].calloutNotations ? (_threeJs$splitScreenD10 = threeJs.splitScreenData) === null || _threeJs$splitScreenD10 === void 0 ? void 0 : _threeJs$splitScreenD10.renderersData["0"].calloutNotations.show : (_threeJs$calloutNotat = threeJs.calloutNotationsData) === null || _threeJs$calloutNotat === void 0 ? void 0 : _threeJs$calloutNotat.show;
  }
  function updateWorld(_x) {
    return _updateWorld.apply(this, arguments);
  }
  function _updateWorld() {
    _updateWorld = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee57(_ref19) {
      var threeJs, target, currentComposition;
      return (0, _regeneratorRuntime2["default"])().wrap(function _callee57$(_context57) {
        while (1) switch (_context57.prev = _context57.next) {
          case 0:
            threeJs = _ref19.threeJs, target = _ref19.target;
            currentComposition = threeJs.currentComposition;
            if (!(currentComposition && threeJs.world)) {
              _context57.next = 11;
              break;
            }
            threeJs.objectsPosition = (0, _construct2["default"])(THREE.Vector3, (0, _toConsumableArray2["default"])(Object.values(currentComposition.objectsPosition && typeof currentComposition.objectsPosition.x === "number" ? currentComposition.objectsPosition : getDefaultObjectsPosition({
              target: target || threeJs.defaultTarget
            }))));
            threeJs.objectsRotation = (0, _construct2["default"])(THREE.Vector3, (0, _toConsumableArray2["default"])(Object.values(currentComposition.objectsRotation && typeof currentComposition.objectsRotation.x === "number" ? currentComposition.objectsRotation : {
              x: 0,
              y: 0,
              z: 0
            })));
            _context57.next = 7;
            return objectsMove(threeJs, threeJs.objectsPosition, threeJs.objectsRotation);
          case 7:
            threeJs.world.position.set(threeJs.objectsPosition.x, threeJs.objectsPosition.y, threeJs.objectsPosition.z);
            threeJs.world.rotation.x = threeJs.objectsRotation.x;
            threeJs.world.rotation.y = threeJs.objectsRotation.y;
            threeJs.world.rotation.z = threeJs.objectsRotation.z;
          case 11:
          case "end":
            return _context57.stop();
        }
      }, _callee57);
    }));
    return _updateWorld.apply(this, arguments);
  }
  function updateWorldWithoutAnimation(_ref20) {
    var threeJs = _ref20.threeJs,
      target = _ref20.target;
    var currentComposition = threeJs.currentComposition;
    if (currentComposition && threeJs.world) {
      threeJs.objectsPosition = (0, _construct2["default"])(THREE.Vector3, (0, _toConsumableArray2["default"])(Object.values(currentComposition.objectsPosition && typeof currentComposition.objectsPosition.x === "number" ? currentComposition.objectsPosition : getDefaultObjectsPosition({
        target: target || threeJs.defaultTarget
      }))));
      threeJs.objectsRotation = (0, _construct2["default"])(THREE.Vector3, (0, _toConsumableArray2["default"])(Object.values(currentComposition.objectsRotation && typeof currentComposition.objectsRotation.x === "number" ? currentComposition.objectsRotation : {
        x: 0,
        y: 0,
        z: 0
      })));
      threeJs.world.position.set(threeJs.objectsPosition.x, threeJs.objectsPosition.y, threeJs.objectsPosition.z);
      threeJs.world.rotation.x = threeJs.objectsRotation.x;
      threeJs.world.rotation.y = threeJs.objectsRotation.y;
      threeJs.world.rotation.z = threeJs.objectsRotation.z;
    }
  }
  function updateCameraUp(_ref21) {
    var threeJs = _ref21.threeJs;
    var na = [0, 2, 3, 4];
    na.forEach(function (n) {
      var cameraPropName = n ? "camera" + n : "camera";
      if (threeJs[cameraPropName]) {
        threeJs[cameraPropName].up.set(threeJs.cameraUp.x, threeJs.cameraUp.y, threeJs.cameraUp.z);
        threeJs[cameraPropName].up.normalize();
      }
    });
  }
  function updateSplitCameraZoom(_ref22) {
    var threeJs = _ref22.threeJs;
    var na = [2, 3, 4];
    na.forEach(function (n) {
      var cameraPropName = n ? "camera" + n : "camera";
      if (threeJs[cameraPropName]) {
        var cameraProps = getCameraProps(n, threeJs);
        threeJs[cameraPropName].zoom = cameraProps.zoom;
        threeJs[cameraPropName].updateProjectionMatrix();
      }
    });
  }
  function setCameraAndWorld() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var threeJs = p.threeJs;
    updateCameraUp({
      threeJs: threeJs
    });
    var _p$cameraProps = p.cameraProps,
      cameraProps = _p$cameraProps === void 0 ? getCameraProps(0, threeJs) : _p$cameraProps;
    cameraProps.set();
    updateWorldWithoutAnimation({
      threeJs: threeJs,
      target: cameraProps.target
    });
    threeJs.updateShadowMap();
    threeJs.camera.updateProjectionMatrix();
    if (threeJs.controls) {
      threeJs.controls.update();
    }
  }
  function setCompositionProperties(_ref23) {
    var threeJs = _ref23.threeJs,
      editor = _ref23.editor;
    setControls({
      threeJs: threeJs,
      editor: editor
    });
    updateLights({
      threeJs: threeJs,
      editor: editor
    });
    updateBackground({
      threeJs: threeJs
    });
    updatePostFilters({
      threeJs: threeJs
    });
    updateCalloutNotations({
      threeJs: threeJs
    });
    threeJs.setButtonsForControls();
  }
  function updateComposition() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var compositions = p.compositions,
      compositionIndex = p.compositionIndex,
      threeJs = p.threeJs,
      toggleSplitScreen = p.toggleSplitScreen,
      editor = p.editor,
      disableChangeObjectsRunAnimation = p.disableChangeObjectsRunAnimation,
      cameraZoom = p.cameraZoom,
      disableFirstRunAnimation = p.disableFirstRunAnimation,
      enableAnimationKeys = p.enableAnimationKeys,
      disableFirstAnimation = p.disableFirstAnimation,
      disableChangeObjectsAnimation = p.disableChangeObjectsAnimation,
      setSplitScreen = p.setSplitScreen,
      initialSplitScreen = p.initialSplitScreen,
      onComplete = p.onComplete,
      nextCompositionIndex = p.nextCompositionIndex,
      selectObject = p.selectObject;
    var currentComposition = compositions[compositionIndex];
    if (currentComposition) {
      var _threeJs$objects;
      var stopAr = /*#__PURE__*/function () {
        var _ref24 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee() {
          var _threeJs$ar, _threeJs$ar$AR;
          var arIsRunning;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                arIsRunning = ((_threeJs$ar = threeJs.ar) === null || _threeJs$ar === void 0 ? void 0 : (_threeJs$ar$AR = _threeJs$ar.AR) === null || _threeJs$ar$AR === void 0 ? void 0 : _threeJs$ar$AR.playState) >= 1;
                if (!arIsRunning) {
                  _context.next = 4;
                  break;
                }
                _context.next = 4;
                return threeJs.ar.stopAR();
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function stopAr() {
          return _ref24.apply(this, arguments);
        };
      }();
      var syncFunctions = function syncFunctions() {
        var _threeJs$splitScreenD11;
        selectObject(threeJs, null, true);
        threeJs.last = {};
        threeJs.needUpdateCameraFromLastComposition = false;
        threeJs.currentComposition = currentComposition;
        updateThreeJsObject({
          threeJs: threeJs,
          editor: editor,
          cameraZoom: cameraZoom
        });
        threeJs.setControlsClickActions();
        threeJs.setDotsForControls({
          dots: compositions.length,
          currentDot: compositionIndex
        });

        // enableAnimation enable requestAnimationFrame
        // disableFirstAnimation disable the element goes in on render
        // disableChangeObjectsAnimation disable elements move between the changing compositions
        // disableFirstRunAnimation disable start animation from data on render
        // disableChangeObjectsRunAnimation disable start animation after composition changeing

        forceEnabledFirstAnimationFromAnimationData = currentComposition.animation && currentComposition.animation[0] === "enableFirstAnimation" && enableAnimationKeys && enableAnimationKeys.indexOf("enableFirstAnimation") > -1 && !disableFirstRunAnimation;
        forceEnabledChangeObjectsAnimationFromAnimationData = currentComposition.animation && currentComposition.animation[currentComposition.animation.length - 1] === "D" && !disableChangeObjectsRunAnimation;
        firstRenderStartFirstAnimation = !(firstRender && disableFirstAnimation && !forceEnabledFirstAnimationFromAnimationData || !threeJs.enableAnimation);
        notFirstRenderStartFirstAnimation = !(!firstRender && disableChangeObjectsAnimation && !forceEnabledChangeObjectsAnimationFromAnimationData || !threeJs.enableAnimation);
        firstRenderStartAnimation = firstRender && !disableFirstRunAnimation || !threeJs.enableAnimation;
        notFirstRenderStartAnimation = !firstRender && !disableChangeObjectsRunAnimation || !threeJs.enableAnimation;
        doSplitScreen = ((_threeJs$splitScreenD11 = threeJs.splitScreenData) === null || _threeJs$splitScreenD11 === void 0 ? void 0 : _threeJs$splitScreenD11.startWithSplitScreen) && !threeJs.splitScreen;
        if (firstRender) {
          setCompositionProperties({
            threeJs: threeJs,
            editor: editor
          });
        }
        if (firstRender) {
          if (firstRenderStartFirstAnimation || firstRenderStartAnimation) {
            threeJs.animationControls.play();
          } else {
            threeJs.animationControls.pause();
          }
        } else {
          if (!(notFirstRenderStartFirstAnimation || notFirstRenderStartAnimation)) {
            threeJs.animationControls.pause();
          }
        }
      };
      var asyncRunAnimation = /*#__PURE__*/function () {
        var _ref30 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee11() {
          var _threeJs$animationCon, animationControlsPlaying;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee11$(_context11) {
            while (1) switch (_context11.prev = _context11.next) {
              case 0:
                if (!(firstRenderStartAnimation || notFirstRenderStartAnimation)) {
                  _context11.next = 13;
                  break;
                }
                _context11.next = 3;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, threeJs.animationProps.waitTimeBeforeAnimation2);
                });
              case 3:
                animationControlsPlaying = (_threeJs$animationCon = threeJs.animationControls) === null || _threeJs$animationCon === void 0 ? void 0 : _threeJs$animationCon.isPlaying();
                if (!animationControlsPlaying) {
                  _context11.next = 10;
                  break;
                }
                _context11.next = 7;
                return startAnimation({
                  threeJs: threeJs,
                  enableAnimationKeys: enableAnimationKeys,
                  animation: currentComposition.animation,
                  toggleSplitScreen: toggleSplitScreen,
                  nextCompositionIndex: nextCompositionIndex
                });
              case 7:
                if (threeJs.animationControls && !threeJs.animationControls.isPlaying() && !threeJs.waitBeforeStartAnimation) {
                  threeJs.animationControls.pause();
                }
                _context11.next = 11;
                break;
              case 10:
                if (threeJs.animationControls) {
                  threeJs.animationControls.pause();
                }
              case 11:
                _context11.next = 14;
                break;
              case 13:
                if (threeJs.animationControls) {
                  threeJs.animationControls.pause();
                }
              case 14:
              case "end":
                return _context11.stop();
            }
          }, _callee11);
        }));
        return function asyncRunAnimation() {
          return _ref30.apply(this, arguments);
        };
      }();
      var run = /*#__PURE__*/function () {
        var _ref31 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee12() {
          var animationControlsPlaying;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee12$(_context12) {
            while (1) switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return stopAr();
              case 2:
                syncFunctions();
                if (!firstRender) {
                  _context12.next = 7;
                  break;
                }
                _context12.next = 6;
                return preloader(threeJs, compositions);
              case 6:
                console.log("[APP] Preloader done");
              case 7:
                animationControlsPlaying = threeJs.animationControls.isPlaying();
                if (!(!firstRenderStartFirstAnimation || !notFirstRenderStartFirstAnimation || !animationControlsPlaying)) {
                  _context12.next = 19;
                  break;
                }
                _context12.next = 11;
                return asyncTreadForAddObjectsWithoutAnimation();
              case 11:
                if (!firstRender) {
                  _context12.next = 17;
                  break;
                }
                _context12.next = 14;
                return threeJs.hideProgress();
              case 14:
                _context12.next = 16;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 16:
                console.log("[APP] Add objects...");
              case 17:
                _context12.next = 27;
                break;
              case 19:
                if (!firstRender) {
                  _context12.next = 25;
                  break;
                }
                _context12.next = 22;
                return threeJs.hideProgress();
              case 22:
                _context12.next = 24;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 24:
                console.log("[APP] Add objects...");
              case 25:
                _context12.next = 27;
                return asyncTreadForAddObjects();
              case 27:
                if (!threeJs.waitBeforeStartAnimation) {
                  _context12.next = 30;
                  break;
                }
                _context12.next = 30;
                return threeJs.waitBeforeStartAnimation;
              case 30:
                _context12.next = 32;
                return asyncRunAnimation();
              case 32:
              case "end":
                return _context12.stop();
            }
          }, _callee12);
        }));
        return function run() {
          return _ref31.apply(this, arguments);
        };
      }();
      console.log("[APP] Set composition", compositionIndex);
      var firstRender = !((_threeJs$objects = threeJs.objects) !== null && _threeJs$objects !== void 0 && _threeJs$objects.children.length);
      threeJs.firstRender = firstRender;
      var doSplitScreen;
      var forceEnabledFirstAnimationFromAnimationData;
      var forceEnabledChangeObjectsAnimationFromAnimationData;
      var firstRenderStartFirstAnimation;
      var notFirstRenderStartFirstAnimation;
      var firstRenderStartAnimation;
      var notFirstRenderStartAnimation;
      var data = currentComposition.data;
      var asyncTreadForAddObjects = /*#__PURE__*/function () {
        var _asyncTread = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee8() {
          var shouldFinal, cameraProps;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                if (!doSplitScreen) {
                  _context8.next = 3;
                  break;
                }
                _context8.next = 9;
                break;
              case 3:
                if (firstRender && initialSplitScreen) {
                  _context8.next = 9;
                  break;
                }
                threeJs.needUpdateCameraFromLastComposition = true;
                _context8.next = 7;
                return setSplitScreen(false);
              case 7:
                threeJs.needUpdateCameraFromLastComposition = false;
                threeJs.setButtonsForControls();
              case 9:
                setControls({
                  threeJs: threeJs,
                  editor: editor
                });
                if (firstRender) {
                  threeJs.shouldFinal = true;
                }
                shouldFinal = threeJs.shouldFinal && (threeJs.lastCompositionIndex === compositions.length - 1 || compositions.length === 1);
                _context8.next = 14;
                return new Promise( /*#__PURE__*/function () {
                  var _ref25 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee6(resolve) {
                    var cameraProps, resolveCameraPos, resolveAddObjects, sI, cI, waitCameraPos, waitAddObjects, _int2;
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee6$(_context6) {
                      while (1) switch (_context6.prev = _context6.next) {
                        case 0:
                          cameraProps = getCameraProps(0, threeJs);
                          resolveCameraPos = false;
                          resolveAddObjects = false;
                          sI = typeof window !== "undefined" && window.timeWeb ? window.timeWeb.o.setInterval : setInterval;
                          cI = typeof window !== "undefined" && window.timeWeb ? window.timeWeb.o.clearInterval : clearInterval;
                          waitCameraPos = /*#__PURE__*/function () {
                            var _ref26 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee4() {
                              var resolveCameraMoveToPosition, resolveUpdateWorld, cameraMoveToPositionHandler, updateWorldHandler, _int;
                              return (0, _regeneratorRuntime2["default"])().wrap(function _callee4$(_context4) {
                                while (1) switch (_context4.prev = _context4.next) {
                                  case 0:
                                    resolveCameraMoveToPosition = false;
                                    resolveUpdateWorld = false;
                                    cameraMoveToPositionHandler = /*#__PURE__*/function () {
                                      var _ref27 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee2() {
                                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee2$(_context2) {
                                          while (1) switch (_context2.prev = _context2.next) {
                                            case 0:
                                              _context2.next = 2;
                                              return cameraMoveToPosition(threeJs, cameraProps.position, cameraProps.target, cameraProps.zoom);
                                            case 2:
                                              resolveCameraMoveToPosition = true;
                                            case 3:
                                            case "end":
                                              return _context2.stop();
                                          }
                                        }, _callee2);
                                      }));
                                      return function cameraMoveToPositionHandler() {
                                        return _ref27.apply(this, arguments);
                                      };
                                    }();
                                    updateWorldHandler = /*#__PURE__*/function () {
                                      var _ref28 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee3() {
                                        return (0, _regeneratorRuntime2["default"])().wrap(function _callee3$(_context3) {
                                          while (1) switch (_context3.prev = _context3.next) {
                                            case 0:
                                              _context3.next = 2;
                                              return updateWorld({
                                                threeJs: threeJs,
                                                cameraProps: cameraProps
                                              });
                                            case 2:
                                              resolveUpdateWorld = true;
                                            case 3:
                                            case "end":
                                              return _context3.stop();
                                          }
                                        }, _callee3);
                                      }));
                                      return function updateWorldHandler() {
                                        return _ref28.apply(this, arguments);
                                      };
                                    }();
                                    cameraMoveToPositionHandler();
                                    updateWorldHandler();
                                    _int = sI(function () {
                                      if (resolveCameraMoveToPosition && resolveUpdateWorld) {
                                        cI(_int);
                                        setCameraAndWorld({
                                          threeJs: threeJs,
                                          cameraProps: cameraProps
                                        });
                                        resolveCameraPos = true;
                                      }
                                    }, 1);
                                  case 7:
                                  case "end":
                                    return _context4.stop();
                                }
                              }, _callee4);
                            }));
                            return function waitCameraPos() {
                              return _ref26.apply(this, arguments);
                            };
                          }();
                          waitAddObjects = /*#__PURE__*/function () {
                            var _ref29 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee5() {
                              return (0, _regeneratorRuntime2["default"])().wrap(function _callee5$(_context5) {
                                while (1) switch (_context5.prev = _context5.next) {
                                  case 0:
                                    if (!firstRender) {
                                      setCompositionProperties({
                                        threeJs: threeJs,
                                        editor: editor
                                      });
                                    }
                                    _context5.next = 3;
                                    return addObjects(threeJs, data, shouldFinal);
                                  case 3:
                                    resolveAddObjects = true;
                                  case 4:
                                  case "end":
                                    return _context5.stop();
                                }
                              }, _callee5);
                            }));
                            return function waitAddObjects() {
                              return _ref29.apply(this, arguments);
                            };
                          }();
                          waitCameraPos();
                          waitAddObjects();
                          threeJs.waitForCameraPosFromUpdateObjects = !resolveCameraPos;
                          _int2 = sI(function () {
                            if (resolveCameraPos) {
                              threeJs.waitForCameraPosFromUpdateObjects = false;
                            }
                            if (resolveCameraPos && resolveAddObjects) {
                              cI(_int2);
                              resolve();
                            }
                          }, 1);
                        case 11:
                        case "end":
                          return _context6.stop();
                      }
                    }, _callee6);
                  }));
                  return function (_x2) {
                    return _ref25.apply(this, arguments);
                  };
                }());
              case 14:
                if (!doSplitScreen) {
                  _context8.next = 24;
                  break;
                }
                _context8.next = 17;
                return setSplitScreen(true);
              case 17:
                threeJs.setButtonsForControls();
                cameraProps = getCameraProps(0, threeJs);
                _context8.next = 21;
                return cameraMoveToPosition(threeJs, cameraProps.position, cameraProps.target, cameraProps.zoom);
              case 21:
                _context8.next = 23;
                return updateWorld({
                  threeJs: threeJs,
                  cameraProps: cameraProps
                });
              case 23:
                setCameraAndWorld({
                  threeJs: threeJs,
                  cameraProps: cameraProps
                });
              case 24:
                console.log("[APP] Call onComplete...");
                if (!onComplete) {
                  _context8.next = 28;
                  break;
                }
                _context8.next = 28;
                return onComplete({
                  canvasTextRenderer: threeJs.canvasTextRenderer,
                  showControls: function () {
                    var _showControls = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee7() {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee7$(_context7) {
                        while (1) switch (_context7.prev = _context7.next) {
                          case 0:
                            _context7.next = 2;
                            return stopAr();
                          case 2:
                            if (!threeJs.animationControls.isPaused()) {
                              _context7.next = 6;
                              break;
                            }
                            threeJs.showControls();
                            _context7.next = 9;
                            break;
                          case 6:
                            if (!threeJs.animationControls.isPlaying()) {
                              _context7.next = 9;
                              break;
                            }
                            _context7.next = 9;
                            return threeJs.animationStop({
                              showControls: true
                            });
                          case 9:
                          case "end":
                            return _context7.stop();
                        }
                      }, _callee7);
                    }));
                    function showControls() {
                      return _showControls.apply(this, arguments);
                    }
                    return showControls;
                  }()
                });
              case 28:
              case "end":
                return _context8.stop();
            }
          }, _callee8);
        }));
        function asyncTread2() {
          return _asyncTread.apply(this, arguments);
        }
        return asyncTread2;
      }();
      var asyncTreadForAddObjectsWithoutAnimation = /*#__PURE__*/function () {
        var _asyncTread2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee10() {
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee10$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                if (!doSplitScreen) {
                  _context10.next = 6;
                  break;
                }
                _context10.next = 3;
                return setSplitScreen(true);
              case 3:
                threeJs.setButtonsForControls();
                _context10.next = 12;
                break;
              case 6:
                if (firstRender && initialSplitScreen) {
                  _context10.next = 12;
                  break;
                }
                threeJs.needUpdateCameraFromLastComposition = true;
                _context10.next = 10;
                return setSplitScreen(false);
              case 10:
                threeJs.needUpdateCameraFromLastComposition = false;
                threeJs.setButtonsForControls();
              case 12:
                setControls({
                  threeJs: threeJs,
                  editor: editor
                });
                setCameraAndWorld({
                  threeJs: threeJs
                });
                if (!firstRender) {
                  setCompositionProperties({
                    threeJs: threeJs,
                    editor: editor
                  });
                }
                _context10.next = 17;
                return addObjectsWithoutAnimation(threeJs, data);
              case 17:
                if (!threeJs.enableAnimation && threeJs.render) {
                  threeJs.render();
                }
                console.log("[APP] Call onComplete...");
                if (!onComplete) {
                  _context10.next = 22;
                  break;
                }
                _context10.next = 22;
                return onComplete({
                  canvasTextRenderer: threeJs.canvasTextRenderer,
                  showControls: function () {
                    var _showControls2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee9() {
                      return (0, _regeneratorRuntime2["default"])().wrap(function _callee9$(_context9) {
                        while (1) switch (_context9.prev = _context9.next) {
                          case 0:
                            _context9.next = 2;
                            return stopAr();
                          case 2:
                            if (!threeJs.animationControls.isPaused()) {
                              _context9.next = 6;
                              break;
                            }
                            threeJs.showControls();
                            _context9.next = 9;
                            break;
                          case 6:
                            if (!threeJs.animationControls.isPlaying()) {
                              _context9.next = 9;
                              break;
                            }
                            _context9.next = 9;
                            return threeJs.animationStop({
                              showControls: true
                            });
                          case 9:
                          case "end":
                            return _context9.stop();
                        }
                      }, _callee9);
                    }));
                    function showControls() {
                      return _showControls2.apply(this, arguments);
                    }
                    return showControls;
                  }()
                });
              case 22:
              case "end":
                return _context10.stop();
            }
          }, _callee10);
        }));
        function asyncTread1() {
          return _asyncTread2.apply(this, arguments);
        }
        return asyncTread1;
      }();
      run();
    }
  }
  function onKeyDown() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var editor = p.editor,
      threeJs = p.threeJs,
      compositions = p.compositions,
      compositionIndex = p.compositionIndex,
      artworkContext = p.artworkContext,
      setCompositionIndex = p.setCompositionIndex,
      forceUpdate = p.forceUpdate,
      cameraMoveByControls = p.cameraMoveByControls,
      setSplitScreen = p.setSplitScreen,
      splitScreen = p.splitScreen,
      selectObject = p.selectObject,
      externalSettings = p.externalSettings;
    var currentComposition = compositions[compositionIndex];
    var handleKeyDown = function handleKeyDown(e) {
      var isCtrl = e.ctrlKey;
      function stopAr() {
        return _stopAr.apply(this, arguments);
      }
      function _stopAr() {
        _stopAr = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee26() {
          var _threeJs$ar3, _threeJs$ar3$AR;
          var arIsRunning;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee26$(_context26) {
            while (1) switch (_context26.prev = _context26.next) {
              case 0:
                arIsRunning = ((_threeJs$ar3 = threeJs.ar) === null || _threeJs$ar3 === void 0 ? void 0 : (_threeJs$ar3$AR = _threeJs$ar3.AR) === null || _threeJs$ar3$AR === void 0 ? void 0 : _threeJs$ar3$AR.playState) >= 1;
                if (!arIsRunning) {
                  _context26.next = 4;
                  break;
                }
                _context26.next = 4;
                return threeJs.ar.stopAR();
              case 4:
              case "end":
                return _context26.stop();
            }
          }, _callee26);
        }));
        return _stopAr.apply(this, arguments);
      }
      if (isCtrl || !editor) {
        if (e.key === "D" || e.key === "d") {
          var asyncFunction = /*#__PURE__*/function () {
            var _ref32 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee13() {
              var generateProps, newCompositions, position, up, target, defaultComp, newIndex;
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee13$(_context13) {
                while (1) switch (_context13.prev = _context13.next) {
                  case 0:
                    _context13.next = 2;
                    return stopAr();
                  case 2:
                    if (!threeJs.animationControls.isPaused()) {
                      _context13.next = 7;
                      break;
                    }
                    threeJs.showControls();
                    if (editor) {
                      if (compositionIndex === compositions.length - 1) {
                        generateProps = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
                          generateType: externalSettings.generateType
                        }, params ? params : {}), {}, {
                          hash: externalSettings.hash
                        });
                        newCompositions = generateCompositions(generateProps).compositions;
                        position = Object.keys(threeJs.camera.position).reduce(function (p, key) {
                          p[key] = Math.round(threeJs.camera.position[key] * 100) / 100;
                          return p;
                        }, {});
                        up = Object.keys(threeJs.camera.up).reduce(function (p, key) {
                          p[key] = Math.round(threeJs.camera.up[key] * 100) / 100;
                          return p;
                        }, {});
                        target = Object.keys(threeJs.target).reduce(function (p, key) {
                          p[key] = Math.round(threeJs.target[key] * 100) / 100;
                          return p;
                        }, {});
                        defaultComp = {
                          background: currentComposition.background || "#eeac56",
                          cameraPosition: {
                            x: position.x,
                            y: position.y,
                            z: position.z
                          },
                          cameraZoom: threeJs.camera.zoom,
                          cameraUp: {
                            x: up.x,
                            y: up.y,
                            z: up.z
                          },
                          cameraTarget: {
                            x: target.x,
                            y: target.y,
                            z: target.z
                          },
                          controlsProps: (0, _objectSpread2["default"])({}, JSON.parse(JSON.stringify(threeJs.controlsProps))),
                          lights: (0, _toConsumableArray2["default"])(JSON.parse(JSON.stringify(threeJs.lights || []))),
                          ambientLight: (0, _objectSpread2["default"])({}, JSON.parse(JSON.stringify(threeJs.ambientLight || []))),
                          animation: (0, _toConsumableArray2["default"])(JSON.parse(JSON.stringify(threeJs.animation || []))),
                          dimensions: (0, _objectSpread2["default"])({}, JSON.parse(JSON.stringify(threeJs.dimensions || {})))
                        };
                        newCompositions.forEach(function (newComp) {
                          compositions.push((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, defaultComp), newComp));
                        });
                      }
                      artworkContext.data.compositions = compositions;
                      setCompositionIndex(compositionIndex + 1);
                      artworkContext.setData(artworkContext.data, true);
                    } else {
                      newIndex = compositions[compositionIndex + 1] ? compositionIndex + 1 : 0;
                      if (compositionIndex === newIndex) {
                        forceUpdate();
                      } else {
                        setCompositionIndex(compositions[compositionIndex + 1] ? compositionIndex + 1 : 0);
                      }
                    }
                    _context13.next = 10;
                    break;
                  case 7:
                    if (!threeJs.animationControls.isPlaying()) {
                      _context13.next = 10;
                      break;
                    }
                    _context13.next = 10;
                    return threeJs.animationStop({
                      showControls: true
                    });
                  case 10:
                  case "end":
                    return _context13.stop();
                }
              }, _callee13);
            }));
            return function asyncFunction() {
              return _ref32.apply(this, arguments);
            };
          }();
          e.preventDefault();
          e.stopPropagation();
          asyncFunction();
        }
        if (e.key === "A" || e.key === "a") {
          var _asyncFunction = /*#__PURE__*/function () {
            var _ref33 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee14() {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee14$(_context14) {
                while (1) switch (_context14.prev = _context14.next) {
                  case 0:
                    _context14.next = 2;
                    return stopAr();
                  case 2:
                    if (!threeJs.animationControls.isPaused()) {
                      _context14.next = 7;
                      break;
                    }
                    threeJs.showControls();
                    setCompositionIndex(compositions[compositionIndex - 1] ? compositionIndex - 1 : compositions.length - 1);
                    _context14.next = 10;
                    break;
                  case 7:
                    if (!threeJs.animationControls.isPlaying()) {
                      _context14.next = 10;
                      break;
                    }
                    _context14.next = 10;
                    return threeJs.animationStop({
                      showControls: true
                    });
                  case 10:
                  case "end":
                    return _context14.stop();
                }
              }, _callee14);
            }));
            return function _asyncFunction() {
              return _ref33.apply(this, arguments);
            };
          }();
          e.preventDefault();
          e.stopPropagation();
          _asyncFunction();
        }
        if (e.key === "s" || e.key === "S") {
          var _asyncFunction2 = /*#__PURE__*/function () {
            var _ref34 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee15() {
              var newIndex;
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee15$(_context15) {
                while (1) switch (_context15.prev = _context15.next) {
                  case 0:
                    _context15.next = 2;
                    return stopAr();
                  case 2:
                    if (!threeJs.animationControls.isPlaying()) {
                      _context15.next = 7;
                      break;
                    }
                    _context15.next = 5;
                    return threeJs.animationStop({
                      showControls: true
                    });
                  case 5:
                    _context15.next = 13;
                    break;
                  case 7:
                    if (!threeJs.animationControls.isPaused()) {
                      _context15.next = 13;
                      break;
                    }
                    _context15.next = 10;
                    return threeJs.animationStop({
                      showControls: true
                    });
                  case 10:
                    threeJs.animationControls.play({
                      showControls: true
                    });
                    newIndex = compositions[compositionIndex + 1] ? compositionIndex + 1 : 0;
                    if (compositionIndex === newIndex) {
                      forceUpdate();
                    } else {
                      setCompositionIndex(compositions[compositionIndex + 1] ? compositionIndex + 1 : 0);
                    }
                  case 13:
                  case "end":
                    return _context15.stop();
                }
              }, _callee15);
            }));
            return function _asyncFunction2() {
              return _ref34.apply(this, arguments);
            };
          }();
          e.preventDefault();
          e.stopPropagation();
          _asyncFunction2();
        }
        if (e.key === " ") {
          var _threeJs$splitScreenD12;
          var _asyncFunction3 = /*#__PURE__*/function () {
            var _ref35 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee16() {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee16$(_context16) {
                while (1) switch (_context16.prev = _context16.next) {
                  case 0:
                    _context16.next = 2;
                    return stopAr();
                  case 2:
                    if (!threeJs.animationControls.isPaused()) {
                      _context16.next = 9;
                      break;
                    }
                    threeJs.showControls();
                    _context16.next = 6;
                    return setSplitScreen(!splitScreen);
                  case 6:
                    threeJs.setButtonsForControls();
                    _context16.next = 12;
                    break;
                  case 9:
                    if (!threeJs.animationControls.isPlaying()) {
                      _context16.next = 12;
                      break;
                    }
                    _context16.next = 12;
                    return threeJs.animationStop({
                      showControls: true
                    });
                  case 12:
                  case "end":
                    return _context16.stop();
                }
              }, _callee16);
            }));
            return function _asyncFunction3() {
              return _ref35.apply(this, arguments);
            };
          }();
          if ((_threeJs$splitScreenD12 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD12 !== void 0 && _threeJs$splitScreenD12.disableChangeSplitScreen) {
            return;
          }
          e.preventDefault();
          e.stopPropagation();
          _asyncFunction3();
        }
        if (e.key === "1") {
          var _asyncFunction4 = /*#__PURE__*/function () {
            var _ref36 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee17() {
              var _threeJs$editLinesDat2;
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee17$(_context17) {
                while (1) switch (_context17.prev = _context17.next) {
                  case 0:
                    _context17.next = 2;
                    return stopAr();
                  case 2:
                    if (!((_threeJs$editLinesDat2 = threeJs.editLinesData) !== null && _threeJs$editLinesDat2 !== void 0 && _threeJs$editLinesDat2.disableChangeEditLines)) {
                      _context17.next = 4;
                      break;
                    }
                    return _context17.abrupt("return");
                  case 4:
                    if (!threeJs.animationControls.isPaused()) {
                      _context17.next = 10;
                      break;
                    }
                    threeJs.showControls();
                    threeJs.toggleShowEditLines();
                    threeJs.setButtonsForControls();
                    _context17.next = 13;
                    break;
                  case 10:
                    if (!threeJs.animationControls.isPlaying()) {
                      _context17.next = 13;
                      break;
                    }
                    _context17.next = 13;
                    return threeJs.animationStop({
                      showControls: true
                    });
                  case 13:
                  case "end":
                    return _context17.stop();
                }
              }, _callee17);
            }));
            return function _asyncFunction4() {
              return _ref36.apply(this, arguments);
            };
          }();
          e.preventDefault();
          e.stopPropagation();
          _asyncFunction4();
        }
        if (e.key === "2") {
          var _asyncFunction5 = /*#__PURE__*/function () {
            var _ref37 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee18() {
              var _threeJs$calloutNotat2;
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee18$(_context18) {
                while (1) switch (_context18.prev = _context18.next) {
                  case 0:
                    _context18.next = 2;
                    return stopAr();
                  case 2:
                    if (!((_threeJs$calloutNotat2 = threeJs.calloutNotationsData) !== null && _threeJs$calloutNotat2 !== void 0 && _threeJs$calloutNotat2.disableChangeCalloutNotations)) {
                      _context18.next = 4;
                      break;
                    }
                    return _context18.abrupt("return");
                  case 4:
                    if (!threeJs.animationControls.isPaused()) {
                      _context18.next = 10;
                      break;
                    }
                    threeJs.showControls();
                    threeJs.toggleShowCalloutNotations();
                    threeJs.setButtonsForControls();
                    _context18.next = 13;
                    break;
                  case 10:
                    if (!threeJs.animationControls.isPlaying()) {
                      _context18.next = 13;
                      break;
                    }
                    _context18.next = 13;
                    return threeJs.animationStop({
                      showControls: true
                    });
                  case 13:
                  case "end":
                    return _context18.stop();
                }
              }, _callee18);
            }));
            return function _asyncFunction5() {
              return _ref37.apply(this, arguments);
            };
          }();
          e.preventDefault();
          e.stopPropagation();
          _asyncFunction5();
        }
        if (e.key === "3") {
          var _threeJs$currentCompo, _threeJs$ar2;
          var _asyncFunction6 = /*#__PURE__*/function () {
            var _ref38 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee19() {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee19$(_context19) {
                while (1) switch (_context19.prev = _context19.next) {
                  case 0:
                    if (!threeJs.animationControls.isPaused()) {
                      _context19.next = 5;
                      break;
                    }
                    _context19.next = 3;
                    return threeJs.ar.toggleAR();
                  case 3:
                    _context19.next = 8;
                    break;
                  case 5:
                    if (!threeJs.animationControls.isPlaying()) {
                      _context19.next = 8;
                      break;
                    }
                    _context19.next = 8;
                    return threeJs.animationStop({
                      showControls: true
                    });
                  case 8:
                  case "end":
                    return _context19.stop();
                }
              }, _callee19);
            }));
            return function _asyncFunction6() {
              return _ref38.apply(this, arguments);
            };
          }();
          e.preventDefault();
          e.stopPropagation();
          if ((_threeJs$currentCompo = threeJs.currentComposition.ar) !== null && _threeJs$currentCompo !== void 0 && _threeJs$currentCompo.enable || (_threeJs$ar2 = threeJs.ar) !== null && _threeJs$ar2 !== void 0 && _threeJs$ar2.AR && threeJs.ar.AR.playState >= 1) {
            _asyncFunction6();
          }
        }
        if (e.key === "5") {
          var _asyncFunction7 = /*#__PURE__*/function () {
            var _ref39 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee20() {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee20$(_context20) {
                while (1) switch (_context20.prev = _context20.next) {
                  case 0:
                    _context20.next = 2;
                    return stopAr();
                  case 2:
                    threeJs.save();
                  case 3:
                  case "end":
                    return _context20.stop();
                }
              }, _callee20);
            }));
            return function _asyncFunction7() {
              return _ref39.apply(this, arguments);
            };
          }();
          e.preventDefault();
          e.stopPropagation();
          _asyncFunction7();
        }
        var keysForSaveByDim = ["6", "7", "8", "9"];
        keysForSaveByDim.forEach(function (key, i) {
          if (e.key === key) {
            var dimKeys = Object.keys(threeJs.dimensions);
            if (dimKeys[i]) {
              var _asyncFunction8 = /*#__PURE__*/function () {
                var _ref40 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee21() {
                  return (0, _regeneratorRuntime2["default"])().wrap(function _callee21$(_context21) {
                    while (1) switch (_context21.prev = _context21.next) {
                      case 0:
                        _context21.next = 2;
                        return stopAr();
                      case 2:
                        threeJs.save(selectedDimension);
                      case 3:
                      case "end":
                        return _context21.stop();
                    }
                  }, _callee21);
                }));
                return function _asyncFunction8() {
                  return _ref40.apply(this, arguments);
                };
              }();
              e.preventDefault();
              e.stopPropagation();
              var selectedDimension = threeJs.dimensions[dimKeys[i]];
              _asyncFunction8();
            }
          }
        });
        if (e.key === "ArrowDown") {
          var _asyncFunction9 = /*#__PURE__*/function () {
            var _ref41 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee22() {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee22$(_context22) {
                while (1) switch (_context22.prev = _context22.next) {
                  case 0:
                    _context22.next = 2;
                    return stopAr();
                  case 2:
                    if (!threeJs.animationControls.isPlaying()) {
                      _context22.next = 5;
                      break;
                    }
                    _context22.next = 5;
                    return threeJs.animationStop({
                      showControls: true
                    });
                  case 5:
                    cameraMoveByControls(threeJs, "center", 900);
                  case 6:
                  case "end":
                    return _context22.stop();
                }
              }, _callee22);
            }));
            return function _asyncFunction9() {
              return _ref41.apply(this, arguments);
            };
          }();
          e.preventDefault();
          e.stopPropagation();
          _asyncFunction9();
        }
        if (e.key === "ArrowUp") {
          var _asyncFunction10 = /*#__PURE__*/function () {
            var _ref42 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee23() {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee23$(_context23) {
                while (1) switch (_context23.prev = _context23.next) {
                  case 0:
                    _context23.next = 2;
                    return stopAr();
                  case 2:
                    if (!threeJs.animationControls.isPlaying()) {
                      _context23.next = 5;
                      break;
                    }
                    _context23.next = 5;
                    return threeJs.animationStop({
                      showControls: true
                    });
                  case 5:
                    cameraMoveByControls(threeJs, "up", 900);
                  case 6:
                  case "end":
                    return _context23.stop();
                }
              }, _callee23);
            }));
            return function _asyncFunction10() {
              return _ref42.apply(this, arguments);
            };
          }();
          e.preventDefault();
          e.stopPropagation();
          _asyncFunction10();
        }
        if (e.key === "ArrowLeft") {
          var _asyncFunction11 = /*#__PURE__*/function () {
            var _ref43 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee24() {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee24$(_context24) {
                while (1) switch (_context24.prev = _context24.next) {
                  case 0:
                    _context24.next = 2;
                    return stopAr();
                  case 2:
                    if (!threeJs.animationControls.isPlaying()) {
                      _context24.next = 5;
                      break;
                    }
                    _context24.next = 5;
                    return threeJs.animationStop({
                      showControls: true
                    });
                  case 5:
                    cameraMoveByControls(threeJs, "left", 900);
                  case 6:
                  case "end":
                    return _context24.stop();
                }
              }, _callee24);
            }));
            return function _asyncFunction11() {
              return _ref43.apply(this, arguments);
            };
          }();
          e.preventDefault();
          e.stopPropagation();
          _asyncFunction11();
        }
        if (e.key === "ArrowRight") {
          var _asyncFunction12 = /*#__PURE__*/function () {
            var _ref44 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee25() {
              return (0, _regeneratorRuntime2["default"])().wrap(function _callee25$(_context25) {
                while (1) switch (_context25.prev = _context25.next) {
                  case 0:
                    _context25.next = 2;
                    return stopAr();
                  case 2:
                    if (!threeJs.animationControls.isPlaying()) {
                      _context25.next = 5;
                      break;
                    }
                    _context25.next = 5;
                    return threeJs.animationStop({
                      showControls: true
                    });
                  case 5:
                    cameraMoveByControls(threeJs, "right", 900);
                  case 6:
                  case "end":
                    return _context25.stop();
                }
              }, _callee25);
            }));
            return function _asyncFunction12() {
              return _ref44.apply(this, arguments);
            };
          }();
          e.preventDefault();
          e.stopPropagation();
          _asyncFunction12();
        }
        if (editor) {
          if (e.key === "X") {
            e.preventDefault();
            e.stopPropagation();
            if (compositions.length > 1) {
              compositions.splice(compositionIndex, 1);
              var newCompositionIndex = compositions[compositionIndex - 1] ? compositionIndex - 1 : 0;
              if (newCompositionIndex !== compositionIndex) {
                setCompositionIndex(compositions[compositionIndex - 1] ? compositionIndex - 1 : 0);
              } else {
                forceUpdate();
              }
              artworkContext.setData(artworkContext.data, true);
            }
          }
          if (e.key === "C") {
            e.preventDefault();
            e.stopPropagation();
            var position = Object.keys(threeJs.camera.position).reduce(function (p, key) {
              p[key] = Math.round(threeJs.camera.position[key] * 1000) / 1000;
              return p;
            }, {});
            var up = Object.keys(threeJs.camera.up).reduce(function (p, key) {
              p[key] = Math.round(threeJs.camera.up[key] * 1000) / 1000;
              return p;
            }, {});
            var target = Object.keys(threeJs.target).reduce(function (p, key) {
              p[key] = Math.round(threeJs.target[key] * 1000) / 1000;
              return p;
            }, {});
            var _currentComposition = compositions[compositionIndex];
            if (_currentComposition) {
              var _threeJs$target;
              _currentComposition.cameraPosition = {
                x: position.x,
                y: position.y,
                z: position.z
              };
              _currentComposition.cameraZoom = threeJs.camera.zoom;
              _currentComposition.cameraUp = {
                x: up.x,
                y: up.y,
                z: up.z
              };
              _currentComposition.cameraTarget = {
                x: target.x,
                y: target.y,
                z: target.z
              };
              threeJs.cameraPosition = {
                x: position.x,
                y: position.y,
                z: position.z
              };
              threeJs.cameraZoom = threeJs.camera.zoom;
              threeJs.cameraUp = {
                x: up.x,
                y: up.y,
                z: up.z
              };
              (_threeJs$target = threeJs.target).set.apply(_threeJs$target, (0, _toConsumableArray2["default"])(Object.values({
                x: target.x,
                y: target.y,
                z: target.z
              })));
              artworkContext.setData(artworkContext.data, true);
            }
          }
          if (e.key === "P") {
            var _threeJs$selectedObje;
            e.preventDefault();
            e.stopPropagation();
            var _currentComposition2 = compositions[compositionIndex];
            var data = _currentComposition2.data;
            var selectedIndex = typeof ((_threeJs$selectedObje = threeJs.selectedObject) === null || _threeJs$selectedObje === void 0 ? void 0 : _threeJs$selectedObje.userData.dataIndex) === "number" ? threeJs.selectedObject.userData.dataIndex : -1;
            var nextIndex = data[selectedIndex + 1] ? selectedIndex + 1 : 0;
            selectObject(threeJs, (0, _toConsumableArray2["default"])(threeJs.objects.children).find(function (o) {
              return o.userData.dataIndex === nextIndex;
            }), true);
          }
          if (e.key === "O") {
            var _threeJs$selectedObje2;
            e.preventDefault();
            e.stopPropagation();
            var _currentComposition3 = compositions[compositionIndex];
            var _data = _currentComposition3.data;
            var _selectedIndex = typeof ((_threeJs$selectedObje2 = threeJs.selectedObject) === null || _threeJs$selectedObje2 === void 0 ? void 0 : _threeJs$selectedObje2.userData.dataIndex) === "number" ? threeJs.selectedObject.userData.dataIndex : -1;
            var prevIndex = _data[_selectedIndex - 1] ? _selectedIndex - 1 : _data.length - 1;
            selectObject(threeJs, (0, _toConsumableArray2["default"])(threeJs.objects.children).find(function (o) {
              return o.userData.dataIndex === prevIndex;
            }), true);
          }
          if (e.altKey) {
            var setSize = function setSize(name) {
              var p = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
              var tempMaterial = threeJs.selectedObject.children[0].material;
              (0, _toConsumableArray2["default"])(threeJs.selectedObject.children).forEach(function (child) {
                threeJs.selectedObject.remove(child);
              });
              threeJs.selectedObject.userData[name] = threeJs.selectedObject.userData[name] + 0.1 * p;
              if (threeJs.selectedObject.userData[name] <= 0.01) {
                threeJs.selectedObject.userData[name] = 0.01;
              }
              threeJs.selectedObject.userData[name] = Math.round(threeJs.selectedObject.userData[name] * 100) / 100;
              var data = currentComposition.data;
              var d = data[threeJs.selectedObject.userData.dataIndex];
              generateMesh(threeJs, threeJs.selectedObject.userData.geometryType, threeJs.selectedObject.userData.geometryProps, threeJs.selectedObject.userData.lineProps, threeJs.selectedObject.userData.width, threeJs.selectedObject.userData.height, threeJs.selectedObject.userData.depth, threeJs.selectedObject.userData.material, d, threeJs.selectedObject);
              threeJs.selectedObject.children[0].material = tempMaterial;
            };
            if (e.key === "J") {
              var _threeJs$selectedObje3;
              e.preventDefault();
              e.stopPropagation();
              var _selectedIndex2 = typeof ((_threeJs$selectedObje3 = threeJs.selectedObject) === null || _threeJs$selectedObje3 === void 0 ? void 0 : _threeJs$selectedObje3.userData.dataIndex) === "number" ? threeJs.selectedObject.userData.dataIndex : -1;
              if (_selectedIndex2 >= 0) {
                setSize("width", -1);
              }
            }
            if (e.key === "K") {
              var _threeJs$selectedObje4;
              e.preventDefault();
              e.stopPropagation();
              var _selectedIndex3 = typeof ((_threeJs$selectedObje4 = threeJs.selectedObject) === null || _threeJs$selectedObje4 === void 0 ? void 0 : _threeJs$selectedObje4.userData.dataIndex) === "number" ? threeJs.selectedObject.userData.dataIndex : -1;
              if (_selectedIndex3 >= 0) {
                setSize("height", -1);
              }
            }
            if (e.key === "L") {
              var _threeJs$selectedObje5;
              e.preventDefault();
              e.stopPropagation();
              var _selectedIndex4 = typeof ((_threeJs$selectedObje5 = threeJs.selectedObject) === null || _threeJs$selectedObje5 === void 0 ? void 0 : _threeJs$selectedObje5.userData.dataIndex) === "number" ? threeJs.selectedObject.userData.dataIndex : -1;
              if (_selectedIndex4 >= 0) {
                setSize("width", 1);
              }
            }
            if (e.key === "I") {
              var _threeJs$selectedObje6;
              e.preventDefault();
              e.stopPropagation();
              var _selectedIndex5 = typeof ((_threeJs$selectedObje6 = threeJs.selectedObject) === null || _threeJs$selectedObje6 === void 0 ? void 0 : _threeJs$selectedObje6.userData.dataIndex) === "number" ? threeJs.selectedObject.userData.dataIndex : -1;
              if (_selectedIndex5 >= 0) {
                setSize("height", 1);
              }
            }
            if (e.key === "B") {
              var _threeJs$selectedObje7;
              e.preventDefault();
              e.stopPropagation();
              var _selectedIndex6 = typeof ((_threeJs$selectedObje7 = threeJs.selectedObject) === null || _threeJs$selectedObje7 === void 0 ? void 0 : _threeJs$selectedObje7.userData.dataIndex) === "number" ? threeJs.selectedObject.userData.dataIndex : -1;
              if (_selectedIndex6 >= 0) {
                setSize("depth", 1);
              }
            }
            if (e.key === "M") {
              var _threeJs$selectedObje8;
              e.preventDefault();
              e.stopPropagation();
              var _selectedIndex7 = typeof ((_threeJs$selectedObje8 = threeJs.selectedObject) === null || _threeJs$selectedObje8 === void 0 ? void 0 : _threeJs$selectedObje8.userData.dataIndex) === "number" ? threeJs.selectedObject.userData.dataIndex : -1;
              if (_selectedIndex7 >= 0) {
                setSize("depth", -1);
              }
            }
          } else {
            if (e.key === "J") {
              var _threeJs$selectedObje9;
              e.preventDefault();
              e.stopPropagation();
              var _selectedIndex8 = typeof ((_threeJs$selectedObje9 = threeJs.selectedObject) === null || _threeJs$selectedObje9 === void 0 ? void 0 : _threeJs$selectedObje9.userData.dataIndex) === "number" ? threeJs.selectedObject.userData.dataIndex : -1;
              if (_selectedIndex8 >= 0) {
                threeJs.selectedObject.position.x = threeJs.selectedObject.position.x - 0.1;
              }
            }
            if (e.key === "K") {
              var _threeJs$selectedObje10;
              e.preventDefault();
              e.stopPropagation();
              var _selectedIndex9 = typeof ((_threeJs$selectedObje10 = threeJs.selectedObject) === null || _threeJs$selectedObje10 === void 0 ? void 0 : _threeJs$selectedObje10.userData.dataIndex) === "number" ? threeJs.selectedObject.userData.dataIndex : -1;
              if (_selectedIndex9 >= 0) {
                threeJs.selectedObject.position.y = threeJs.selectedObject.position.y - 0.1;
              }
            }
            if (e.key === "L") {
              var _threeJs$selectedObje11;
              e.preventDefault();
              e.stopPropagation();
              var _selectedIndex10 = typeof ((_threeJs$selectedObje11 = threeJs.selectedObject) === null || _threeJs$selectedObje11 === void 0 ? void 0 : _threeJs$selectedObje11.userData.dataIndex) === "number" ? threeJs.selectedObject.userData.dataIndex : -1;
              if (_selectedIndex10 >= 0) {
                threeJs.selectedObject.position.x = threeJs.selectedObject.position.x + 0.1;
              }
            }
            if (e.key === "I") {
              var _threeJs$selectedObje12;
              e.preventDefault();
              e.stopPropagation();
              var _selectedIndex11 = typeof ((_threeJs$selectedObje12 = threeJs.selectedObject) === null || _threeJs$selectedObje12 === void 0 ? void 0 : _threeJs$selectedObje12.userData.dataIndex) === "number" ? threeJs.selectedObject.userData.dataIndex : -1;
              if (_selectedIndex11 >= 0) {
                threeJs.selectedObject.position.y = threeJs.selectedObject.position.y + 0.1;
              }
            }
            if (e.key === "B") {
              var _threeJs$selectedObje13;
              e.preventDefault();
              e.stopPropagation();
              var _selectedIndex12 = typeof ((_threeJs$selectedObje13 = threeJs.selectedObject) === null || _threeJs$selectedObje13 === void 0 ? void 0 : _threeJs$selectedObje13.userData.dataIndex) === "number" ? threeJs.selectedObject.userData.dataIndex : -1;
              if (_selectedIndex12 >= 0) {
                threeJs.selectedObject.position.z = threeJs.selectedObject.position.z + 0.1;
              }
            }
            if (e.key === "M") {
              var _threeJs$selectedObje14;
              e.preventDefault();
              e.stopPropagation();
              var _selectedIndex13 = typeof ((_threeJs$selectedObje14 = threeJs.selectedObject) === null || _threeJs$selectedObje14 === void 0 ? void 0 : _threeJs$selectedObje14.userData.dataIndex) === "number" ? threeJs.selectedObject.userData.dataIndex : -1;
              if (_selectedIndex13 >= 0) {
                threeJs.selectedObject.position.z = threeJs.selectedObject.position.z - 0.1;
              }
            }
          }
          if (e.key === "Delete") {
            var _threeJs$selectedObje15;
            e.preventDefault();
            e.stopPropagation();
            var _selectedIndex14 = typeof ((_threeJs$selectedObje15 = threeJs.selectedObject) === null || _threeJs$selectedObje15 === void 0 ? void 0 : _threeJs$selectedObje15.userData.dataIndex) === "number" ? threeJs.selectedObject.userData.dataIndex : -1;
            if (_selectedIndex14 >= 0) {
              var selectedObject = threeJs.selectedObject;
              var _currentComposition4 = compositions[compositionIndex];
              if (_currentComposition4) {
                selectObject(threeJs, null, true);
                _currentComposition4.data.splice(_selectedIndex14, 1);
                threeJs.objects.remove(selectedObject);
                artworkContext.setData(artworkContext.data, true);
              }
            }
          }
          if (e.key === "Backspace") {
            var _threeJs$selectedObje16;
            e.preventDefault();
            e.stopPropagation();
            var _selectedIndex15 = typeof ((_threeJs$selectedObje16 = threeJs.selectedObject) === null || _threeJs$selectedObje16 === void 0 ? void 0 : _threeJs$selectedObje16.userData.dataIndex) === "number" ? threeJs.selectedObject.userData.dataIndex : -1;
            if (_selectedIndex15 >= 0) {
              var _currentComposition5 = compositions[compositionIndex];
              if (_currentComposition5) {
                (0, _toConsumableArray2["default"])(threeJs.selectedObject.children).forEach(function (child) {
                  threeJs.selectedObject.remove(child);
                });
                var _data2 = _currentComposition5.data;
                var d = _data2[threeJs.selectedObject.userData.dataIndex];
                threeJs.selectedObject.userData.geometryType = d.geometryType;
                threeJs.selectedObject.userData.geometryProps = d.geometryProps;
                threeJs.selectedObject.userData.lineProps = d.lineProps;
                threeJs.selectedObject.userData.width = d.width;
                threeJs.selectedObject.userData.height = d.height;
                threeJs.selectedObject.userData.depth = d.depth;
                generateMesh(threeJs, d.geometryType, d.geometryProps, d.lineProps, d.width, d.height, d.depth, d.material, d, threeJs.selectedObject);
                var _position = _currentComposition5.data[_selectedIndex15].position;
                threeJs.selectedObject.position.x = _position.x;
                threeJs.selectedObject.position.y = _position.y;
                threeJs.selectedObject.position.z = _position.z;
                selectObject(threeJs, null, true);
              }
            }
          }
          if (e.key === "Enter") {
            var _threeJs$selectedObje17;
            e.preventDefault();
            e.stopPropagation();
            var _selectedIndex16 = typeof ((_threeJs$selectedObje17 = threeJs.selectedObject) === null || _threeJs$selectedObje17 === void 0 ? void 0 : _threeJs$selectedObje17.userData.dataIndex) === "number" ? threeJs.selectedObject.userData.dataIndex : -1;
            if (_selectedIndex16 >= 0) {
              var _position2 = Object.keys(threeJs.selectedObject.position).reduce(function (p, key) {
                p[key] = Math.round(threeJs.selectedObject.position[key] * 100) / 100;
                return p;
              }, {});
              var _currentComposition6 = compositions[compositionIndex];
              if (_currentComposition6) {
                _currentComposition6.data[_selectedIndex16].position = {
                  x: _position2.x,
                  y: _position2.y,
                  z: _position2.z
                };
                _currentComposition6.data[_selectedIndex16].geometryType = threeJs.selectedObject.userData.geometryType;
                _currentComposition6.data[_selectedIndex16].geometryProps = threeJs.selectedObject.userData.geometryProps;
                _currentComposition6.data[_selectedIndex16].lineProps = threeJs.selectedObject.userData.lineProps;
                _currentComposition6.data[_selectedIndex16].width = threeJs.selectedObject.userData.width;
                _currentComposition6.data[_selectedIndex16].height = threeJs.selectedObject.userData.height;
                _currentComposition6.data[_selectedIndex16].depth = threeJs.selectedObject.userData.depth;
                artworkContext.setData(artworkContext.data, true);
                selectObject(threeJs, null, true);
              }
            }
          }
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return function () {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }
  function addDimFunctions() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var threeJs = p.threeJs;
    threeJs.getWidthAndHeight = function (n) {
      var _threeJs$splitScreenD13, _threeJs$splitScreenD14, _threeJs$splitScreenD15, _threeJs$splitScreenD16, _threeJs$splitScreenD17, _threeJs$splitScreenD18, _threeJs$splitScreenD19, _threeJs$splitScreenD20, _threeJs$splitScreenD21, _threeJs$splitScreenD22;
      var p = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var splitScreen = threeJs.splitScreen;
      var parentContainer = threeJs.parentContainer;
      var _p$parentWidth = p.parentWidth,
        parentWidth = _p$parentWidth === void 0 ? parentContainer.offsetWidth : _p$parentWidth,
        _p$parentHeight = p.parentHeight,
        parentHeight = _p$parentHeight === void 0 ? parentContainer.offsetHeight : _p$parentHeight;
      var oW = (splitScreen || n > 0) && (_threeJs$splitScreenD13 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD13 !== void 0 && _threeJs$splitScreenD13.renderersData && (_threeJs$splitScreenD14 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD14 !== void 0 && _threeJs$splitScreenD14.renderersData["" + n] && (_threeJs$splitScreenD15 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD15 !== void 0 && _threeJs$splitScreenD15.renderersData["" + n].width && !isNaN(Number((_threeJs$splitScreenD16 = threeJs.splitScreenData) === null || _threeJs$splitScreenD16 === void 0 ? void 0 : _threeJs$splitScreenD16.renderersData["" + n].width)) ? 100 / Number((_threeJs$splitScreenD17 = threeJs.splitScreenData) === null || _threeJs$splitScreenD17 === void 0 ? void 0 : _threeJs$splitScreenD17.renderersData["" + n].width) : 2;
      var oH = (splitScreen || n > 0) && (_threeJs$splitScreenD18 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD18 !== void 0 && _threeJs$splitScreenD18.renderersData && (_threeJs$splitScreenD19 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD19 !== void 0 && _threeJs$splitScreenD19.renderersData["" + n] && (_threeJs$splitScreenD20 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD20 !== void 0 && _threeJs$splitScreenD20.renderersData["" + n].height && !isNaN(Number((_threeJs$splitScreenD21 = threeJs.splitScreenData) === null || _threeJs$splitScreenD21 === void 0 ? void 0 : _threeJs$splitScreenD21.renderersData["" + n].height)) ? 100 / Number((_threeJs$splitScreenD22 = threeJs.splitScreenData) === null || _threeJs$splitScreenD22 === void 0 ? void 0 : _threeJs$splitScreenD22.renderersData["" + n].height) : 2;
      parentHeight = parentHeight > parentWidth ? parentWidth : parentHeight;
      var width = splitScreen || n > 0 ? parentWidth / oW : parentWidth;
      var height = splitScreen || n > 0 ? parentHeight / oH : parentHeight;
      var originalHeight = height;
      if (width / height < 1) {
        height = width;
      }
      return {
        width: width,
        height: height,
        originalHeight: originalHeight
      };
    };
    threeJs.getLeftAndTop = function (n) {
      var _threeJs$splitScreenD23, _threeJs$splitScreenD24, _threeJs$splitScreenD25, _threeJs$splitScreenD26, _threeJs$splitScreenD27, _threeJs$splitScreenD28, _threeJs$splitScreenD29, _threeJs$splitScreenD30;
      var p = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var splitScreen = threeJs.splitScreen;
      var _threeJs$getWidthAndH2 = threeJs.getWidthAndHeight(n, p),
        width = _threeJs$getWidthAndH2.width,
        height = _threeJs$getWidthAndH2.height,
        originalHeight = _threeJs$getWidthAndH2.originalHeight;
      var parentContainer = threeJs.parentContainer;
      var _p$parentWidth2 = p.parentWidth,
        parentWidth = _p$parentWidth2 === void 0 ? parentContainer.offsetWidth : _p$parentWidth2,
        _p$parentHeight2 = p.parentHeight,
        parentHeight = _p$parentHeight2 === void 0 ? parentContainer.offsetHeight : _p$parentHeight2;
      var oX = (splitScreen || n > 0) && (_threeJs$splitScreenD23 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD23 !== void 0 && _threeJs$splitScreenD23.renderersData && (_threeJs$splitScreenD24 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD24 !== void 0 && _threeJs$splitScreenD24.renderersData["" + n] && typeof ((_threeJs$splitScreenD25 = threeJs.splitScreenData) === null || _threeJs$splitScreenD25 === void 0 ? void 0 : _threeJs$splitScreenD25.renderersData["" + n].left) === "number" ? (_threeJs$splitScreenD26 = threeJs.splitScreenData) === null || _threeJs$splitScreenD26 === void 0 ? void 0 : _threeJs$splitScreenD26.renderersData["" + n].left : splitScreen && n === 0 ? 0 : n === 2 ? 0 : n === 3 ? 50 : n === 4 ? 50 : 0;
      var oY = (splitScreen || n > 0) && (_threeJs$splitScreenD27 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD27 !== void 0 && _threeJs$splitScreenD27.renderersData && (_threeJs$splitScreenD28 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD28 !== void 0 && _threeJs$splitScreenD28.renderersData["" + n] && typeof ((_threeJs$splitScreenD29 = threeJs.splitScreenData) === null || _threeJs$splitScreenD29 === void 0 ? void 0 : _threeJs$splitScreenD29.renderersData["" + n].top) === "number" ? (_threeJs$splitScreenD30 = threeJs.splitScreenData) === null || _threeJs$splitScreenD30 === void 0 ? void 0 : _threeJs$splitScreenD30.renderersData["" + n].top : splitScreen && n === 0 ? 50 : n === 2 ? 0 : n === 3 ? 0 : n === 4 ? 50 : 0;
      var containerHeight = parentWidth / parentHeight < 1 ? parentWidth : parentHeight;
      var startY = parentWidth / parentHeight < 1 ? (parentHeight - containerHeight) / 2 / parentHeight * 100 : 0;
      if (originalHeight > width) {
        startY = startY + (originalHeight - width) / 2 / parentHeight * 100;
      }
      var left = oX + width / 2 / parentWidth * 100;
      var top = startY + oY * containerHeight / 100 / parentHeight * 100 + height / 2 / parentHeight * 100;
      return {
        left: left,
        top: top
      };
    };
    threeJs.getVisibility = function (n) {
      var _threeJs$splitScreenD31, _threeJs$splitScreenD32, _threeJs$splitScreenD33, _threeJs$splitScreenD34;
      var splitScreen = threeJs.splitScreen;
      return {
        visibility: (splitScreen || n > 0) && (_threeJs$splitScreenD31 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD31 !== void 0 && _threeJs$splitScreenD31.renderersData && (_threeJs$splitScreenD32 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD32 !== void 0 && _threeJs$splitScreenD32.renderersData["" + n] && (_threeJs$splitScreenD33 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD33 !== void 0 && _threeJs$splitScreenD33.renderersData["" + n].visibility ? (_threeJs$splitScreenD34 = threeJs.splitScreenData) === null || _threeJs$splitScreenD34 === void 0 ? void 0 : _threeJs$splitScreenD34.renderersData["" + n].visibility : "visible"
      };
    };
  }
  function init() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wapp = p.wapp,
      threeJs = p.threeJs,
      canvasBackgroundContainer = p.canvasBackgroundContainer,
      container = p.container,
      effects = p.effects,
      composition = p.composition,
      arContainer = p.arContainer,
      editor = p.editor,
      selectObject = p.selectObject,
      style = p.style;
    if (wapp.globals.DEV) {
      window.threeJs = threeJs;
    }
    if (typeof window !== "undefined" && window.timeWeb) {
      window.timeWeb.callbackStep = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee27() {
        var sT;
        return (0, _regeneratorRuntime2["default"])().wrap(function _callee27$(_context27) {
          while (1) switch (_context27.prev = _context27.next) {
            case 0:
              threeJs.render(window.timeWeb.ct);
              sT = window.timeWeb.o.setTimeout;
              _context27.next = 4;
              return new Promise(function (resolve) {
                return sT(resolve, 100);
              });
            case 4:
            case "end":
              return _context27.stop();
          }
        }, _callee27);
      }));
    }
    if (!threeJs.parentContainer) {
      threeJs.parentContainer = container.current;
    }
    if (!threeJs.canvasBackgroundContainer) {
      threeJs.canvasBackgroundContainer = canvasBackgroundContainer.current;
    }
    if (!threeJs.effectsContainer) {
      threeJs.effectsContainer = effects.current;
    }
    if (!threeJs.arContainer) {
      threeJs.arContainer = arContainer.current;
    }
    function addRenderers() {
      if (!threeJs.camera) {
        addCameraAndRenderer({
          threeJs: threeJs,
          domElement: composition.current,
          style: style
        });
      }
      if (!threeJs.camera2) {
        addCameraAndRenderer((0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({
          threeJs: threeJs,
          domElement: composition.current,
          cameraPropName: "camera2",
          rendererPropName: "renderer2"
        }, threeJs.getWidthAndHeight(2)), threeJs.getLeftAndTop(2)), threeJs.getVisibility(2)), {}, {
          style: style
        }));
      }
      if (!threeJs.camera3) {
        addCameraAndRenderer((0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({
          threeJs: threeJs,
          domElement: composition.current,
          cameraPropName: "camera3",
          rendererPropName: "renderer3"
        }, threeJs.getWidthAndHeight(3)), threeJs.getLeftAndTop(3)), threeJs.getVisibility(3)), {}, {
          style: style
        }));
      }
      if (!threeJs.camera4) {
        addCameraAndRenderer((0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({
          threeJs: threeJs,
          domElement: composition.current,
          cameraPropName: "camera4",
          rendererPropName: "renderer4"
        }, threeJs.getWidthAndHeight(4)), threeJs.getLeftAndTop(4)), threeJs.getVisibility(4)), {}, {
          style: style
        }));
      }
    }
    function initGraphics() {
      threeJs.scene = new THREE.Scene();

      //threeJs.scene.fog = new THREE.FogExp2( "#f3b470", 0.1 );

      /*Objects*/

      threeJs.world = new THREE.Group();
      threeJs.lightsOnScene = new THREE.Group();
      threeJs.lightsHelpers = new THREE.Group();
      threeJs.objects = new THREE.Group();
      threeJs.objects.userData.onRender = function (_ref46) {
        var camera = _ref46.camera,
          n = _ref46.n;
        if (camera) {
          var _threeJs$splitScreenD35, _threeJs$splitScreenD36, _threeJs$splitScreenD37;
          var nD = !n ? 1 : n;
          var editLinesData = (threeJs.splitScreen || n > 0) && (_threeJs$splitScreenD35 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD35 !== void 0 && _threeJs$splitScreenD35.renderersData && (_threeJs$splitScreenD36 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD36 !== void 0 && _threeJs$splitScreenD36.renderersData["" + n] && (_threeJs$splitScreenD37 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD37 !== void 0 && _threeJs$splitScreenD37.renderersData["" + n].editLines ? threeJs.splitScreenData.renderersData["" + n].editLines : threeJs.editLinesData;
          if (editLinesData !== null && editLinesData !== void 0 && editLinesData.show && threeJs.showEditLines) {
            camera.layers.enable(nD * 6 + 1);
          } else {
            camera.layers.disable(nD * 6 + 1);
          }
        }
        if (camera) {
          var _threeJs$splitScreenD38, _threeJs$splitScreenD39, _threeJs$splitScreenD40;
          var _nD = !n ? 1 : n;
          var calloutNotationsData = (threeJs.splitScreen || n > 0) && (_threeJs$splitScreenD38 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD38 !== void 0 && _threeJs$splitScreenD38.renderersData && (_threeJs$splitScreenD39 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD39 !== void 0 && _threeJs$splitScreenD39.renderersData["" + n] && (_threeJs$splitScreenD40 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD40 !== void 0 && _threeJs$splitScreenD40.renderersData["" + n].calloutNotations ? threeJs.splitScreenData.renderersData["" + n].calloutNotations : threeJs.calloutNotationsData;
          if (calloutNotationsData !== null && calloutNotationsData !== void 0 && calloutNotationsData.show && threeJs.showCalloutNotations) {
            camera.layers.enable(_nD * 6 + 2);
          } else {
            camera.layers.disable(_nD * 6 + 2);
          }
        }
        if (camera) {
          var _nD2 = !n ? 1 : n;
          if (threeJs.showShadowObjects) {
            camera.layers.enable(_nD2 * 6 + 3);
          } else {
            camera.layers.disable(_nD2 * 6 + 3);
          }
        }
      };
      threeJs.scene.add(threeJs.world);
      threeJs.world.add(threeJs.objects);
      threeJs.world.add(threeJs.lightsOnScene);
      threeJs.world.add(threeJs.lightsHelpers);
    }
    function initRayCasterInputForSelect() {
      var doClickOnRelease = false;
      var click = function click(e) {
        if (doClickOnRelease && editor) {
          var _intersects$, _intersects$$object;
          var findParent = function findParent(object) {
            if (object && typeof object.userData.dataIndex === "number") {
              return object;
            } else if (object && object.parent) {
              return findParent(object.parent);
            }
          };
          var _threeJs$renderer$dom = threeJs.renderer.domElement.getBoundingClientRect(),
            top = _threeJs$renderer$dom.top,
            left = _threeJs$renderer$dom.left,
            width = _threeJs$renderer$dom.width,
            height = _threeJs$renderer$dom.height;
          threeJs.pointer.x = -1 + 2 * (e.clientX - left) / width;
          threeJs.pointer.y = 1 - 2 * (e.clientY - top) / height;
          threeJs.raycaster.setFromCamera(threeJs.pointer, threeJs.camera);
          var intersects = threeJs.raycaster.intersectObjects(threeJs.objects.children, true);
          var object = (_intersects$ = intersects[0]) === null || _intersects$ === void 0 ? void 0 : (_intersects$$object = _intersects$.object) === null || _intersects$$object === void 0 ? void 0 : _intersects$$object.parent;
          var parent = findParent(object);
          if (parent) {
            console.log("[APP]", "Select object:", parent.userData.dataIndex, parent.userData);
            selectObject(threeJs, parent, true);
          }
        }
        if (doClickOnRelease && !editor) {
          var _threeJs$renderer$dom2 = threeJs.renderer.domElement.getBoundingClientRect(),
            _top = _threeJs$renderer$dom2.top,
            _left = _threeJs$renderer$dom2.left,
            _width = _threeJs$renderer$dom2.width,
            _height = _threeJs$renderer$dom2.height;
          threeJs.pointer.x = -1 + 2 * (e.clientX - _left) / _width;
          threeJs.pointer.y = 1 - 2 * (e.clientY - _top) / _height;
          threeJs.raycaster.setFromCamera(threeJs.pointer, threeJs.camera);
          var _intersects = threeJs.raycaster.intersectObjects(threeJs.objects.children, true);
          if (_intersects.length) {
            var done = false;
            _intersects.forEach(function (intersectData) {
              var object = intersectData === null || intersectData === void 0 ? void 0 : intersectData.object;
              if (done || !object) {
                return;
              }
              function findParent(object) {
                var _object$userData, _object$userData$data;
                if (object !== null && object !== void 0 && (_object$userData = object.userData) !== null && _object$userData !== void 0 && (_object$userData$data = _object$userData.data) !== null && _object$userData$data !== void 0 && _object$userData$data.onClick) {
                  return object;
                } else if (object && object.parent) {
                  return findParent(object.parent);
                }
              }
              var parent = findParent(object);
              if (parent) {
                var asyncFunction = /*#__PURE__*/function () {
                  var _ref47 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee28() {
                    var state, nextAction, nextState, rest;
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee28$(_context28) {
                      while (1) switch (_context28.prev = _context28.next) {
                        case 0:
                          _context28.next = 2;
                          return threeJs.animationStop();
                        case 2:
                          state = typeof parent.userData.state === "number" ? parent.userData.state : parent.userData.data.onClick.state || 0;
                          nextAction = parent.userData.data.onClick.actions && parent.userData.data.onClick.actions[state];
                          if (!nextAction) {
                            _context28.next = 9;
                            break;
                          }
                          nextState = nextAction.nextState, rest = (0, _objectWithoutProperties2["default"])(nextAction, _excluded2);
                          parent.userData.state = typeof nextState === "number" ? nextState : 0;
                          _context28.next = 9;
                          return objectMove((0, _objectSpread2["default"])({
                            threeJs: threeJs,
                            object: parent,
                            position: parent.position,
                            rotation: parent.rotation
                          }, rest));
                        case 9:
                        case "end":
                          return _context28.stop();
                      }
                    }, _callee28);
                  }));
                  return function asyncFunction() {
                    return _ref47.apply(this, arguments);
                  };
                }();
                done = true;
                asyncFunction();
              }
            });
          }
        }
      };
      var down = function down() {
        doClickOnRelease = true;
      };
      var move = function move() {
        doClickOnRelease = false;
      };
      threeJs.renderer.domElement.addEventListener("click", click);
      threeJs.renderer.domElement.addEventListener("mousedown", down);
      threeJs.renderer.domElement.addEventListener("mousemove", move);
      threeJs.renderer.domElement.addEventListener("touchstart", down);
      threeJs.renderer.domElement.addEventListener("touchmove", move);
      threeJs.removeRayCasterInputForSelectListeners = function () {
        if (threeJs.renderer.domElement) {
          threeJs.renderer.domElement.removeEventListener("click", click);
          threeJs.renderer.domElement.removeEventListener("mousedown", down);
          threeJs.renderer.domElement.removeEventListener("mousemove", move);
          threeJs.renderer.domElement.removeEventListener("touchstart", down);
          threeJs.renderer.domElement.removeEventListener("touchmove", move);
        }
      };
    }
    function initControls() {
      setCameraAndWorld({
        threeJs: threeJs
      });
      var OrbitControls = threeJs.packages.OrbitControls;
      threeJs.controls = new OrbitControls(threeJs.camera, threeJs.renderer.domElement);
      threeJs.controls.target = threeJs.target;
      threeJs.controls.update();
      threeJs.controls.rotateSpeed = 1;
      threeJs.controls.staticMoveing = true;
      threeJs.controls.dynamicDampingFactor = 1;
      threeJs.controls.noPan = false;
      threeJs.controls.noZoom = false;
      threeJs.controls.enableZoom = true;
      threeJs.controls.enablePan = true;
      threeJs.controls.enableDamping = false;
      if (!editor) {
        threeJs.controls.noPan = true;
        threeJs.controls.enablePan = false;
        threeJs.controls.enableZoom = false;
        threeJs.controls.noZoom = true;
      }
      setControls({
        threeJs: threeJs,
        editor: editor
      });
      threeJs.enableControlsPlayButton();
      function onClickFunction() {
        return _onClickFunction.apply(this, arguments);
      }
      function _onClickFunction() {
        _onClickFunction = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee30() {
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee30$(_context30) {
            while (1) switch (_context30.prev = _context30.next) {
              case 0:
                if (!threeJs.getControlsShow()) {
                  _context30.next = 5;
                  break;
                }
                _context30.next = 3;
                return threeJs.toggleShowControls();
              case 3:
                _context30.next = 10;
                break;
              case 5:
                _context30.next = 7;
                return threeJs.toggleShowControls();
              case 7:
                if (!threeJs.animationControls.isPlaying()) {
                  _context30.next = 10;
                  break;
                }
                _context30.next = 10;
                return threeJs.animationStop();
              case 10:
              case "end":
                return _context30.stop();
            }
          }, _callee30);
        }));
        return _onClickFunction.apply(this, arguments);
      }
      function justClick() {
        return _justClick.apply(this, arguments);
      }
      function _justClick() {
        _justClick = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee31() {
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee31$(_context31) {
            while (1) switch (_context31.prev = _context31.next) {
              case 0:
                onClickFunction();
              case 1:
              case "end":
                return _context31.stop();
            }
          }, _callee31);
        }));
        return _justClick.apply(this, arguments);
      }
      function onMoveOnce() {
        function asyncFunction() {
          return _asyncFunction13.apply(this, arguments);
        }
        function _asyncFunction13() {
          _asyncFunction13 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee29() {
            return (0, _regeneratorRuntime2["default"])().wrap(function _callee29$(_context29) {
              while (1) switch (_context29.prev = _context29.next) {
                case 0:
                  if (!threeJs.animationControls.isPlaying()) {
                    _context29.next = 3;
                    break;
                  }
                  _context29.next = 3;
                  return threeJs.animationStop({
                    showControls: true
                  });
                case 3:
                case "end":
                  return _context29.stop();
              }
            }, _callee29);
          }));
          return _asyncFunction13.apply(this, arguments);
        }
        asyncFunction();
      }
      var start = function start() {
        threeJs.userCameraMoveingRunStopAnimationOnce = false;
        threeJs.userCameraMoveing = 0;
        threeJs.startControlsMoveEvent = true;
      };
      var end = function end(e) {
        if (!threeJs.userCameraMoveing) {
          justClick(e);
        }
        threeJs.userCameraMoveingRunStopAnimationOnce = false;
        threeJs.userCameraMoveing = 0;
        threeJs.startControlsMoveEvent = false;
      };
      var move = function move() {
        if (threeJs.startControlsMoveEvent) {
          threeJs.userCameraMoveing = 1;
          if (!threeJs.userCameraMoveingRunStopAnimationOnce) {
            threeJs.userCameraMoveingRunStopAnimationOnce = true;
            onMoveOnce();
          }
        }
      };
      function findParent(e, p) {
        if (e && e === p) {
          return true;
        }
        if (e && e.parentElement && e.parentElement === p) {
          return true;
        }
        if (e && e.parentElement) {
          return findParent(e.parentElement, p);
        }
      }
      var globalClickListener = function globalClickListener(e) {
        if (threeJs.parentContainer) {
          var isInsideClick = findParent(e.target, threeJs.parentContainer);
          var isClickToRenderer = findParent(e.target, threeJs.renderer.domElement);
          if (isInsideClick && !isClickToRenderer) {
            onClickFunction();
          }
        }
      };
      threeJs.removeControlListeners = function () {
        threeJs.controls.removeEventListener("start", start);
        threeJs.controls.removeEventListener("change", move);
        threeJs.controls.removeEventListener("end", end);
        window.removeEventListener("click", globalClickListener);
      };
      threeJs.controls.addEventListener("start", start);
      threeJs.controls.addEventListener("change", move);
      threeJs.controls.addEventListener("end", end);
      window.addEventListener("click", globalClickListener, false);
    }
    function init() {
      initGraphics();
      addRenderers();
      initControls();
      initRayCasterInputForSelect();
    }
    function onResize() {
      if (threeJs.onResize) {
        threeJs.onResize();
      }
    }
    function addResizeListeners() {
      if (threeJs.parentContainer && typeof ResizeObserver !== "undefined") {
        var resizeObserver = new ResizeObserver(function (entries) {
          onResize(entries);
        });
        resizeObserver.observe(threeJs.parentContainer);
        return function removeEventListener() {
          resizeObserver.disconnect();
        };
      } else {
        window.addEventListener("resize", onResize);
        return function removeEventListener() {
          window.removeEventListener("resize", onResize);
        };
      }
    }
    var removeResizeListeners = addResizeListeners();
    threeJs.render = function (time) {
      var _threeJs$objectAnim, _threeJs$ar4;
      if (threeJs.reqId) {
        cancelAnimationFrame(threeJs.reqId);
      }
      var isTimeWeb = typeof window !== "undefined" && window.timeWeb;
      if (threeJs.enableAnimation && !isTimeWeb) {
        threeJs.reqId = requestAnimationFrame(threeJs.render);
      }
      if (threeJs.controls) {
        if (threeJs.enableAnimation) {
          threeJs.controls.enabled = true;
          threeJs.controls.update();
        } else {
          threeJs.controls.enabled = false;
        }
      }
      if (threeJs.enableAnimation && threeJs.cameraAnim) {
        threeJs.cameraAnim(time);
      }
      if (threeJs.enableAnimation && threeJs.objectsAnim) {
        threeJs.objectsAnim(time);
      }
      if (threeJs.enableAnimation && (_threeJs$objectAnim = threeJs.objectAnim) !== null && _threeJs$objectAnim !== void 0 && _threeJs$objectAnim.length) {
        threeJs.objectAnim.forEach(function (func) {
          func(time);
        });
        threeJs.objectAnim = [];
      }
      if (threeJs.animationBeforeRender) {
        threeJs.animationBeforeRender(time);
      }
      try {
        TWEEN.update(time);
      } catch (e) {
        console.log("[APP]", "TweenJs error", e);
      }
      if ((_threeJs$ar4 = threeJs.ar) !== null && _threeJs$ar4 !== void 0 && _threeJs$ar4.onRender) {
        threeJs.ar.onRender();
      }
      var na = [2, 3, 4];
      na.forEach(function (n) {
        var cameraPropName = !n ? "camera" : "camera" + n;
        if (threeJs[cameraPropName]) {
          var mainCameraSpherical = getNCameraPosSpherical({
            n: 0,
            position: threeJs.camera.position,
            threeJs: threeJs
          });
          if (n === 3) {
            mainCameraSpherical.spherical.phi = 0.000001;
          }
          if (n === 2) {
            mainCameraSpherical.spherical.theta = 0.000001;
          }
          if (n === 4) {
            mainCameraSpherical.spherical.phi = threeJs.controlsProps.maxPolarAngle - 0.02 < Math.PI / 2 ? threeJs.controlsProps.maxPolarAngle : Math.PI / 2;
          }
          mainCameraSpherical.spherical.makeSafe();
          var mainCameraDefaultPosSpherical = getNCameraPosSpherical({
            n: 0,
            threeJs: threeJs
          });
          var diffTheta = mainCameraSpherical.spherical.theta - mainCameraDefaultPosSpherical.spherical.theta;
          var diffPhi = mainCameraSpherical.spherical.phi - mainCameraDefaultPosSpherical.spherical.phi;
          var cameraSpherical = getNCameraPosSpherical({
            n: n,
            threeJs: threeJs
          });
          cameraSpherical.spherical.theta = cameraSpherical.spherical.theta + diffTheta;
          cameraSpherical.spherical.phi = cameraSpherical.spherical.phi + diffPhi;
          cameraSpherical.spherical.makeSafe();
          cameraSpherical.offset.setFromSpherical(cameraSpherical.spherical);
          cameraSpherical.offset.applyQuaternion(cameraSpherical.quatInverse);
          threeJs[cameraPropName].position.copy(cameraSpherical.target).add(cameraSpherical.offset);
          threeJs[cameraPropName].lookAt(cameraSpherical.target);
        }
      });
      if (threeJs.renderType === "SVG" || threeJs.renderType === "WebGL") {
        if (threeJs.renderType === "SVG") {
          threeJs.objects.children.forEach(function (object, i) {
            var order = (object.position.x + object.position.z) * 10 + (i + 1);
            object.renderOrder = order;
            object.children[0].renderOrder = order;
            if (object.children[1]) {
              object.children[1].renderOrder = order;
            }
            if (object.children[3]) {
              object.children[3].renderOrder = order;
              if (object.children[3].children[0]) {
                object.children[3].children.forEach(function (child) {
                  child.renderOrder = order + 1;
                });
              }
            }
            if (object.children[0].children[0] && object.children[0].children[0].children[1]) {
              (0, _toConsumableArray2["default"])(Array(6)).forEach(function (value, i) {
                if (object.children[0].children[i]) {
                  object.children[0].children[i].renderOrder = order;
                  if (object.children[0].children[i].children[0]) {
                    object.children[0].children[i].children[0].renderOrder = order;
                  }
                  if (object.children[0].children[i].children[1]) {
                    if (i === 0 || i === 1) {
                      object.children[0].children[i].children[1].renderOrder = order + 1;
                    } else {
                      object.children[0].children[i].children[1].renderOrder = order;
                    }
                  }
                }
              });
            }
          });
        }
        var _na = threeJs.splitScreen ? [0, 2, 3, 4] : [0];
        _na.forEach(function (n) {
          var rendererPropName = n ? "renderer" + n : "renderer";
          var cameraPropName = n ? "camera" + n : "camera";
          if (threeJs[cameraPropName]) {
            var nD = !n ? 1 : n;
            threeJs[cameraPropName].layers.enable(nD * 6);
            threeJs[cameraPropName].layers.enable(nD * 6 + 1);
            threeJs[cameraPropName].layers.enable(nD * 6 + 2);
            threeJs[cameraPropName].layers.enable(nD * 6 + 3);
          }
          threeJs.world.traverse(function (c) {
            var _c$userData;
            if (c !== null && c !== void 0 && (_c$userData = c.userData) !== null && _c$userData !== void 0 && _c$userData.onRender) {
              c.userData.onRender({
                camera: threeJs[cameraPropName],
                n: n
              });
            }
          });
          if (threeJs[rendererPropName]) {
            /*if (Math.floor(time % 2) !== 0 && threeJs[rendererPropName].shadowMap) {
                threeJs[rendererPropName].shadowMap.needsUpdate = false;
            }*/

            if (threeJs[rendererPropName].composer) {
              threeJs[rendererPropName].renderComposer();
            } else {
              threeJs[rendererPropName].render(threeJs.scene, threeJs[cameraPropName]);
            }
          }
        });
      }
    };
    threeJs.onResize = function () {
      var _threeJs$ar5, _threeJs$ar5$AR;
      var _ref48 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        disableSetCanvasBackground = _ref48.disableSetCanvasBackground,
        forceResizeAllRenderer = _ref48.forceResizeAllRenderer,
        resizeRenderers = _ref48.resizeRenderers,
        disableLeftAndTop = _ref48.disableLeftAndTop;
      if (!disableSetCanvasBackground) {
        setCanvasBackground({
          threeJs: threeJs
        });
      }
      var n = resizeRenderers ? resizeRenderers : threeJs.splitScreen || forceResizeAllRenderer ? [0, 2, 3, 4] : [0];
      n.forEach(function (n) {
        var cameraPropName = n ? "camera" + n : "camera";
        var rendererPropName = n ? "renderer" + n : "renderer";
        if (threeJs[cameraPropName] && threeJs[rendererPropName]) {
          var _threeJs$getWidthAndH3 = threeJs.getWidthAndHeight(n),
            width = _threeJs$getWidthAndH3.width,
            height = _threeJs$getWidthAndH3.height;
          var _threeJs$getLeftAndTo = threeJs.getLeftAndTop(n),
            left = _threeJs$getLeftAndTo.left,
            top = _threeJs$getLeftAndTo.top;
          if (threeJs[rendererPropName].effectElement) {
            threeJs[rendererPropName].effectElement.setAttribute("width", width);
            threeJs[rendererPropName].effectElement.setAttribute("height", height);
            threeJs[rendererPropName].effectElement.style.width = width + "px";
            threeJs[rendererPropName].effectElement.style.height = height + "px";
            if (!disableLeftAndTop) {
              threeJs[rendererPropName].effectElement.style.left = left + "%";
              threeJs[rendererPropName].effectElement.style.top = top + "%";
            }
          }
          threeJs[rendererPropName].domElement.style.width = width + "px";
          threeJs[rendererPropName].domElement.style.height = height + "px";
          if (!disableLeftAndTop) {
            threeJs[rendererPropName].domElement.style.left = left + "%";
            threeJs[rendererPropName].domElement.style.top = top + "%";
          }
          threeJs[cameraPropName].aspect = width / height;
          threeJs[cameraPropName].left = -threeJs.cameraD * threeJs[cameraPropName].aspect;
          threeJs[cameraPropName].right = threeJs.cameraD * threeJs[cameraPropName].aspect;
          threeJs[cameraPropName].top = threeJs.cameraD;
          threeJs[cameraPropName].bottom = -threeJs.cameraD;
          threeJs[cameraPropName].updateProjectionMatrix();
          if (threeJs[rendererPropName].composer) {
            threeJs[rendererPropName].composer.setSize(width, height);
          }
          threeJs[rendererPropName].setSize(width, height);
          if (n === 0 && threeJs.arContainer) {
            threeJs.arContainer.style.width = width + "px";
            threeJs.arContainer.style.height = height + "px";
            if (!disableLeftAndTop) {
              threeJs.arContainer.style.left = left + "%";
              threeJs.arContainer.style.top = top + "%";
            }
          }
        }
      });
      threeJs.objects.traverse(function (c) {
        var _c$material, _c$geometry;
        if (c !== null && c !== void 0 && (_c$material = c.material) !== null && _c$material !== void 0 && _c$material.resize) {
          c.material.resize({
            camera: threeJs.camera
          });
        }
        if (c !== null && c !== void 0 && (_c$geometry = c.geometry) !== null && _c$geometry !== void 0 && _c$geometry.resize) {
          c.geometry.resize({
            camera: threeJs.camera
          });
        }
      });
      if ((_threeJs$ar5 = threeJs.ar) !== null && _threeJs$ar5 !== void 0 && (_threeJs$ar5$AR = _threeJs$ar5.AR) !== null && _threeJs$ar5$AR !== void 0 && _threeJs$ar5$AR.resize) {
        var _threeJs$ar6, _threeJs$ar6$AR;
        (_threeJs$ar6 = threeJs.ar) === null || _threeJs$ar6 === void 0 ? void 0 : (_threeJs$ar6$AR = _threeJs$ar6.AR) === null || _threeJs$ar6$AR === void 0 ? void 0 : _threeJs$ar6$AR.resize();
      }
      if (!threeJs.enableAnimation && threeJs.render) {
        threeJs.render();
      }
    };
    init();
    threeJs.render();
    threeJs.onResize({
      forceResizeAllRenderer: true
    });
    return function willUnmount() {
      console.log("[APP]", "Unmount");
      threeJs.render = function () {
        if (threeJs.reqId) {
          cancelAnimationFrame(threeJs.reqId);
        }
      };
      if (threeJs.reqId) {
        cancelAnimationFrame(threeJs.reqId);
      }
      removeResizeListeners();
      if (threeJs.removeRayCasterInputForSelectListeners) {
        threeJs.removeRayCasterInputForSelectListeners();
      }
      if (threeJs.removeControlListeners && threeJs.controls) {
        threeJs.removeControlListeners();
      }
      if (threeJs.runningAnimationResolve) {
        threeJs.runningAnimationResolve();
      }
      if (threeJs.waitBeforeStartAnimationResolve) {
        threeJs.waitBeforeStartAnimationResolve();
      }
      [0, 2, 3, 4].forEach(function (n) {
        var rendererPropName = n ? "renderer" + n : "renderer";
        var cameraPropName = n ? "camera" + n : "camera";
        if (threeJs[rendererPropName] && threeJs[rendererPropName].domElement && threeJs[rendererPropName].domElement.parentElement) {
          threeJs[rendererPropName].domElement.parentElement.removeChild(threeJs[rendererPropName].domElement);
          if (threeJs[cameraPropName]) {
            threeJs[cameraPropName] = null;
          }
          if (threeJs[rendererPropName]) {
            if (threeJs[rendererPropName].dispose) {
              threeJs[rendererPropName].dispose();
            }
            threeJs[rendererPropName] = null;
          }
        }
      });
      setTimeout(function () {
        Object.keys(threeJs).forEach(function (key) {
          delete threeJs[key];
        });
      }, 15000);
    };
  }
  function cameraPosIsDefault() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var threeJs = p.threeJs,
      _p$cameraPropsData = p.cameraPropsData,
      cameraPropsData = _p$cameraPropsData === void 0 ? {} : _p$cameraPropsData;
    var currentCameraProps = getCameraProps(0, threeJs, (0, _objectSpread2["default"])({}, cameraPropsData));
    return !["x", "y", "z"].find(function (key) {
      return Math.round(currentCameraProps.position[key] * 10) / 10 !== Math.round(threeJs.camera.position[key] * 10) / 10;
    });
  }
  function setCameraPosIfItsDefault() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var threeJs = p.threeJs,
      _p$cameraPropsData2 = p.cameraPropsData,
      cameraPropsData = _p$cameraPropsData2 === void 0 ? {} : _p$cameraPropsData2;
    var currentCameraProps = getCameraProps(0, threeJs, (0, _objectSpread2["default"])({
      splitScreen: threeJs.lastSplitScreen
    }, cameraPropsData));
    var isDefaultPos = !["x", "y", "z"].find(function (key) {
      return Math.round(currentCameraProps.position[key] * 10) / 10 !== Math.round(threeJs.camera.position[key] * 10) / 10;
    });
    var isDefaultTarget = !["x", "y", "z"].find(function (key) {
      return Math.round(currentCameraProps.target[key] * 10) / 10 !== Math.round(threeJs.target[key] * 10) / 10;
    });
    var isDefaultZoom = Math.round(currentCameraProps.zoom * 10) / 10 === Math.round(threeJs.camera.zoom * 10) / 10;
    var cameraProps = getCameraProps(0, threeJs, (0, _objectSpread2["default"])({}, cameraPropsData));
    if (isDefaultPos && isDefaultTarget && isDefaultZoom) {
      cameraProps.set();
    } else if (isDefaultZoom) {
      threeJs.camera.zoom = cameraProps.zoom;
      threeJs.updateShadowMap();
      threeJs.camera.updateProjectionMatrix();
      if (threeJs.controls) {
        threeJs.controls.update();
      }
    }
  }
  function createTween(_ref49) {
    var threeJs = _ref49.threeJs,
      from = _ref49.from,
      to = _ref49.to,
      _ref49$time = _ref49.time,
      time = _ref49$time === void 0 ? 500 : _ref49$time,
      update = _ref49.update,
      resolve = _ref49.resolve,
      group = _ref49.group;
    var tween = new TWEEN.Tween(from, group).to(to, time).onUpdate(function (from) {
      update((0, _objectSpread2["default"])({}, from));
    }).easing(TWEEN.Easing.Quadratic.InOut).onComplete(function () {
      update((0, _objectSpread2["default"])({}, to));
      tween.stop();
      if (threeJs.runningTweens.indexOf(tween) > -1) {
        threeJs.runningTweens.splice(threeJs.runningTweens.indexOf(tween), 1);
      }
      resolve();
    });
    threeJs.runningTweens.push(tween);
    return tween;
  }
  function parseNumberFromElementStylePercent(e, style, def) {
    var sp = e.style[style];
    if (sp.slice(-1) === "%") {
      sp = sp.slice(0, -1);
    }
    if (!isNaN(Number(sp))) {
      return Number(sp);
    }
    return def;
  }
  function updateRenderer() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var threeJs = p.threeJs,
      rendererPropName = p.rendererPropName,
      n = p.n;
    var d = p.data || {};
    var data = (0, _objectSpread2["default"])({}, d);
    function round(n) {
      return Math.round(n * 100) / 100;
    }
    Object.keys(data).forEach(function (key) {
      data[key] = round(data[key]);
    });
    Object.keys(data).forEach(function (key) {
      threeJs[rendererPropName].domElement.style[key] = key === "opacity" ? data[key] : data[key] + "%";
      if (threeJs[rendererPropName].effectElement && threeJs[rendererPropName].effectElement.parentElement) {
        threeJs[rendererPropName].effectElement.style[key] = key === "opacity" ? data[key] : data[key] + "%";
      }
      var canvasBackgroundContainer = threeJs.canvasBackgroundContainer;
      if (canvasBackgroundContainer) {
        var canvasBackgroundChildren = (0, _toConsumableArray2["default"])(canvasBackgroundContainer.children);
        var cI = n === 0 ? 1 : n;
        if (canvasBackgroundChildren[cI]) {
          canvasBackgroundChildren[cI].style[key] = key === "opacity" ? data[key] : data[key] + "%";
        }
      }
    });
  }
  function createTweenForRenderer(_ref50) {
    var threeJs = _ref50.threeJs,
      rendererPropName = _ref50.rendererPropName,
      n = _ref50.n,
      to = _ref50.to,
      _ref50$def = _ref50.def,
      def = _ref50$def === void 0 ? {} : _ref50$def,
      _ref50$resolve = _ref50.resolve,
      _resolve = _ref50$resolve === void 0 ? function () {} : _ref50$resolve;
    var _def$opacity = def.opacity,
      opacity = _def$opacity === void 0 ? 1 : _def$opacity,
      _def$marginLeft = def.marginLeft,
      marginLeft = _def$marginLeft === void 0 ? 0 : _def$marginLeft,
      _def$top = def.top,
      top = _def$top === void 0 ? 0 : _def$top,
      _def$left = def.left,
      left = _def$left === void 0 ? 0 : _def$left;
    function _update() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      updateRenderer({
        threeJs: threeJs,
        data: data,
        rendererPropName: rendererPropName,
        n: n
      });
    }
    var parsedFrom = {
      opacity: parseNumberFromElementStylePercent(threeJs[rendererPropName].domElement, "opacity", opacity),
      marginLeft: parseNumberFromElementStylePercent(threeJs[rendererPropName].domElement, "marginLeft", marginLeft),
      top: parseNumberFromElementStylePercent(threeJs[rendererPropName].domElement, "top", top),
      left: parseNumberFromElementStylePercent(threeJs[rendererPropName].domElement, "left", left)
    };
    var f = Object.keys(to).reduce(function (o, key) {
      o[key] = parsedFrom[key];
      return o;
    }, {});
    var t = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, f), to);
    var notEqual = Object.keys(f).find(function (key) {
      return f[key] !== t[key];
    });
    var time = notEqual ? 800 : 100;
    var tween = createTween({
      threeJs: threeJs,
      from: f,
      to: t,
      time: time,
      update: function update() {
        _update((0, _objectSpread2["default"])({}, f));
      },
      resolve: function resolve() {
        _update((0, _objectSpread2["default"])({}, t));
        _resolve();
      }
    });
    var ct = typeof window !== "undefined" && window.timeWeb ? window.timeWeb.ct : undefined;
    tween.start(ct);
  }
  function updateRenderers() {
    var _threeJs$splitScreenD41, _threeJs$objects2;
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var threeJs = p.threeJs,
      disableFirstRunAnimation = p.disableFirstRunAnimation,
      disableChangeObjectsRunAnimation = p.disableChangeObjectsRunAnimation;
    var splitScreen = threeJs.splitScreen;
    [0, 2, 3, 4].forEach(function (n) {
      var rendererPropName = n ? "renderer" + n : "renderer";
      if (threeJs[rendererPropName] && threeJs[rendererPropName].domElement && threeJs[rendererPropName].domElement.parentElement) {
        var _threeJs$getVisibilit = threeJs.getVisibility(n),
          visibility = _threeJs$getVisibilit.visibility;
        threeJs[rendererPropName].domElement.style.visibility = visibility;
      }
    });
    var borderStyle = splitScreen && (_threeJs$splitScreenD41 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD41 !== void 0 && _threeJs$splitScreenD41.hideBorders ? "none" : "";
    [0, 2, 3, 4].forEach(function (n) {
      var rendererPropName = n ? "renderer" + n : "renderer";
      if (threeJs[rendererPropName] && threeJs[rendererPropName].domElement) {
        threeJs[rendererPropName].domElement.style.borderStyle = borderStyle;
      }
    });
    var firstRender = threeJs.firstRender || !((_threeJs$objects2 = threeJs.objects) !== null && _threeJs$objects2 !== void 0 && _threeJs$objects2.children.length);
    var firstRenderStartAnimation = firstRender && !disableFirstRunAnimation || !threeJs.enableAnimation;
    var notFirstRenderStartAnimation = !firstRender && !disableChangeObjectsRunAnimation || !threeJs.enableAnimation;
    var animationControlsPlaying = threeJs.animationControls.isPlaying();
    var splitRenderers = [2, 3, 4];
    if (threeJs.needUpdateCameraFromLastComposition) {
      var _threeJs$last, _threeJs$last2, _threeJs$last3, _threeJs$last4;
      setCameraPosIfItsDefault({
        threeJs: threeJs,
        cameraPropsData: {
          splitScreenData: (_threeJs$last = threeJs.last) === null || _threeJs$last === void 0 ? void 0 : _threeJs$last.splitScreenData,
          cameraPosition: (_threeJs$last2 = threeJs.last) === null || _threeJs$last2 === void 0 ? void 0 : _threeJs$last2.cameraPosition,
          defaultTarget: (_threeJs$last3 = threeJs.last) === null || _threeJs$last3 === void 0 ? void 0 : _threeJs$last3.defaultTarget,
          cameraZoom: (_threeJs$last4 = threeJs.last) === null || _threeJs$last4 === void 0 ? void 0 : _threeJs$last4.cameraZoom
        }
      });
      threeJs.needUpdateCameraFromLastComposition = false;
    } else {
      setCameraPosIfItsDefault({
        threeJs: threeJs
      });
    }
    if (firstRenderStartAnimation && animationControlsPlaying || notFirstRenderStartAnimation && animationControlsPlaying) {
      threeJs.onResize({
        disableSetCanvasBackground: true,
        resizeRenderers: [2, 3, 4]
      });
      threeJs.onResize({
        disableSetCanvasBackground: true,
        resizeRenderers: [0],
        disableLeftAndTop: true
      });
      var promises = [];
      var _threeJs$getLeftAndTo2 = threeJs.getLeftAndTop(0),
        left = _threeJs$getLeftAndTo2.left,
        top = _threeJs$getLeftAndTo2.top;
      setCanvasBackground({
        threeJs: threeJs,
        disableLeftAndTop: true
      });
      promises.push(new Promise(function (_resolve2) {
        createTweenForRenderer({
          threeJs: threeJs,
          rendererPropName: "renderer",
          n: 0,
          to: {
            top: top,
            left: left
          },
          def: {
            top: 0,
            left: 0
          },
          resolve: function resolve() {
            threeJs.onResize({
              disableSetCanvasBackground: true,
              resizeRenderers: [0]
            });
            _resolve2();
          }
        });
      }));
      if (splitScreen) {
        var afterTweens = /*#__PURE__*/function () {
          var _ref51 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee32() {
            return (0, _regeneratorRuntime2["default"])().wrap(function _callee32$(_context32) {
              while (1) switch (_context32.prev = _context32.next) {
                case 0:
                  _context32.next = 2;
                  return Promise.all(promises);
                case 2:
                  if (threeJs.waitForChangeSplitScreenResolve) {
                    threeJs.waitForChangeSplitScreenResolve();
                  }
                case 3:
                case "end":
                  return _context32.stop();
              }
            }, _callee32);
          }));
          return function afterTweens() {
            return _ref51.apply(this, arguments);
          };
        }();
        updatePostFilters({
          threeJs: threeJs
        });
        updateSplitCameraZoom({
          threeJs: threeJs
        });
        splitRenderers.forEach(function (n) {
          var rendererPropName = n ? "renderer" + n : "renderer";
          if (threeJs[rendererPropName] && threeJs[rendererPropName].domElement && threeJs[rendererPropName].domElement.parentElement) {
            promises.push(new Promise(function (resolve) {
              createTweenForRenderer({
                threeJs: threeJs,
                rendererPropName: rendererPropName,
                n: n,
                to: {
                  opacity: 1,
                  marginLeft: 0
                },
                def: {
                  opacity: 0,
                  marginLeft: n === 2 ? -20 : 20
                },
                resolve: resolve
              });
            }));
          }
        });
        afterTweens();
      } else {
        var _afterTweens = /*#__PURE__*/function () {
          var _ref52 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee33() {
            return (0, _regeneratorRuntime2["default"])().wrap(function _callee33$(_context33) {
              while (1) switch (_context33.prev = _context33.next) {
                case 0:
                  _context33.next = 2;
                  return Promise.all(promises);
                case 2:
                  updatePostFilters({
                    threeJs: threeJs
                  });
                  if (threeJs.waitForChangeSplitScreenResolve) {
                    threeJs.waitForChangeSplitScreenResolve();
                  }
                case 4:
                case "end":
                  return _context33.stop();
              }
            }, _callee33);
          }));
          return function _afterTweens() {
            return _ref52.apply(this, arguments);
          };
        }();
        splitRenderers.forEach(function (n) {
          var rendererPropName = n ? "renderer" + n : "renderer";
          if (threeJs[rendererPropName] && threeJs[rendererPropName].domElement && threeJs[rendererPropName].domElement.parentElement) {
            promises.push(new Promise(function (resolve) {
              createTweenForRenderer({
                threeJs: threeJs,
                rendererPropName: rendererPropName,
                n: n,
                to: {
                  opacity: 0,
                  marginLeft: n === 2 ? -20 : 20
                },
                def: {
                  opacity: 1,
                  marginLeft: 0
                },
                resolve: resolve
              });
            }));
          }
        });
        _afterTweens();
      }
    } else {
      threeJs.onResize();
      updatePostFilters({
        threeJs: threeJs
      });
      if (splitScreen) {
        updateSplitCameraZoom({
          threeJs: threeJs
        });
        splitRenderers.forEach(function (n) {
          var rendererPropName = n ? "renderer" + n : "renderer";
          if (threeJs[rendererPropName] && threeJs[rendererPropName].domElement && threeJs[rendererPropName].domElement.parentElement) {
            updateRenderer({
              threeJs: threeJs,
              data: {
                opacity: 1,
                marginLeft: 0
              },
              rendererPropName: rendererPropName,
              n: n
            });
          }
        });
      } else {
        splitRenderers.forEach(function (n) {
          var rendererPropName = n ? "renderer" + n : "renderer";
          if (threeJs[rendererPropName] && threeJs[rendererPropName].domElement && threeJs[rendererPropName].domElement.parentElement) {
            updateRenderer({
              threeJs: threeJs,
              data: {
                opacity: 0,
                marginLeft: n === 2 ? -20 : 20
              },
              rendererPropName: rendererPropName,
              n: n
            });
          }
        });
      }
      if (threeJs.waitForChangeSplitScreenResolve) {
        threeJs.waitForChangeSplitScreenResolve();
      }
    }
  }
  function getAnimationControls() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _p$controlsRef = p.controlsRef,
      controlsRef = _p$controlsRef === void 0 ? {} : _p$controlsRef;
    var states = {
      paused: 0,
      waitForPause: 1,
      playing: 2
    };
    function setControlsState() {
      var _controlsRef$current;
      var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (controlsRef !== null && controlsRef !== void 0 && (_controlsRef$current = controlsRef.current) !== null && _controlsRef$current !== void 0 && _controlsRef$current.actions) {
        controlsRef.current.actions.setState({
          show: p.showControls,
          timeout: p.timeoutForControls,
          playState: animationControls.currentState
        });
      }
    }
    var animationControls = {
      currentState: states.paused,
      play: function play(p) {
        if (!animationControls.isPlaying()) {
          console.log("[APP]", "Animation controls, prev state:", animationControls.currentState, "next state:", states.playing);
          animationControls.currentState = states.playing;
          setControlsState(p);
        }
      },
      waitForPause: function waitForPause(p) {
        if (animationControls.isPlaying()) {
          console.log("[APP]", "Animation controls, prev state:", animationControls.currentState, "next state:", states.waitForPause);
          animationControls.currentState = states.waitForPause;
          setControlsState(p);
        }
      },
      pause: function pause(p) {
        if (animationControls.isPlaying() || animationControls.currentState === states.waitForPause) {
          console.log("[APP]", "Animation controls, prev state:", animationControls.currentState, "next state:", states.paused);
          animationControls.currentState = states.paused;
          setControlsState(p);
        }
      },
      isPlaying: function isPlaying() {
        return animationControls.currentState === states.playing;
      },
      isPaused: function isPaused() {
        return animationControls.currentState === states.paused;
      }
    };
    return animationControls;
  }
  function getARFunctions() {
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var threeJs = p.threeJs,
      editor = p.editor,
      setSplitScreen = p.setSplitScreen,
      DEV = p.DEV;
    var tempShowCalloutNotations;
    var tempShowEditLines;
    var tempShowShadowObjects;
    var tempFov;
    var boundingBox;
    var worldWidth;
    var worldDepth;
    var lastPoints = [];
    var leftSection;
    var rightSection;
    var cObject = new THREE.Object3D();
    var pObject = new THREE.Object3D();
    var onStart = false;
    var testObject;
    if (DEV) {
      testObject = new THREE.Object3D();
      (0, _toConsumableArray2["default"])(Array(468 + 1).fill(0)).forEach(function () {
        var geometry = new THREE.SphereGeometry(1, 32, 16);
        var material = new THREE.MeshBasicMaterial({
          color: "#00ffff"
        });
        var sphere = new THREE.Mesh(geometry, material);
        sphere.layers.enable(6);
        testObject.add(sphere);
      });
    }
    function init() {
      if (DEV) {
        testObject.layers.enable(6);
        threeJs.scene.add(testObject);
      }
    }
    function reset() {
      ar.onRender = function () {};
      if (typeof tempFov === "number") {
        threeJs.camera.fov = tempFov;
      }
      resetSection(leftSection);
      resetSection(rightSection);
      threeJs.objects.rotation.x = 0;
      threeJs.objects.rotation.y = 0;
      threeJs.objects.rotation.z = 0;
      setCameraAndWorld({
        threeJs: threeJs
      });
      setControls({
        threeJs: threeJs,
        editor: editor
      });
      threeJs.controls.enabled = true;
      if (typeof tempShowCalloutNotations == "boolean") {
        threeJs.showCalloutNotations = tempShowCalloutNotations;
        tempShowCalloutNotations = undefined;
      }
      if (typeof tempShowEditLines == "boolean") {
        threeJs.showEditLines = tempShowEditLines;
        tempShowEditLines = undefined;
      }
      if (typeof tempShowShadowObjects == "boolean") {
        threeJs.showShadowObjects = tempShowShadowObjects;
        tempShowShadowObjects = undefined;
      }
      threeJs.world.scale.set(1, 1, 1);
      if ((0, _toConsumableArray2["default"])(threeJs.scene.children).indexOf(cObject) !== -1) {
        threeJs.scene.remove(cObject);
      }
      if ((0, _toConsumableArray2["default"])(threeJs.objects.children).indexOf(pObject) !== -1) {
        threeJs.objects.remove(pObject);
      }
      boundingBox = null;
      worldWidth = null;
      worldDepth = null;
      onStart = false;
    }
    function isChanged() {
      var _lastPoints;
      var minChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
      var points = arguments.length > 1 ? arguments[1] : undefined;
      if (!((_lastPoints = lastPoints) !== null && _lastPoints !== void 0 && _lastPoints.length)) {
        lastPoints = (0, _toConsumableArray2["default"])(points);
        return true;
      }
      var found = points.find(function (point, i) {
        if (lastPoints[i]) {
          if (point.x > lastPoints[i].x + minChange || point.x < lastPoints[i].x - minChange) {
            return true;
          }
          if (point.y > lastPoints[i].y + minChange || point.y < lastPoints[i].y - minChange) {
            return true;
          }
          if (point.z > lastPoints[i].z + minChange || point.z < lastPoints[i].z - minChange) {
            return true;
          }
        } else {
          return true;
        }
        return false;
      });
      if (found) {
        lastPoints = (0, _toConsumableArray2["default"])(points);
        return true;
      }
      return false;
    }
    function selectObjects(_ref53) {
      var object = _ref53.object,
        rangeX = _ref53.rangeX,
        rangeY = _ref53.rangeY,
        rangeZ = _ref53.rangeZ;
      var children = (0, _toConsumableArray2["default"])(object.children);
      return children.filter(function (child) {
        var _child$userData;
        var userData = (_child$userData = child.userData) === null || _child$userData === void 0 ? void 0 : _child$userData.data;
        if (userData) {
          var isOnRangeX = true;
          if (rangeX) {
            var minX = userData.position.x - userData.width / 2;
            var maxX = userData.position.x + userData.width / 2;
            if (rangeX[0] > maxX || rangeX[1] < minX) {
              isOnRangeX = false;
            }
          }
          var isOnRangeY = true;
          if (rangeY) {
            var minY = userData.position.y - userData.height / 2;
            var maxY = userData.position.y + userData.height / 2;
            if (rangeY[0] > maxY || rangeY[1] < minY) {
              isOnRangeY = false;
            }
          }
          var isOnRangeZ = true;
          if (rangeZ) {
            var minZ = userData.position.z - userData.depth / 2;
            var maxZ = userData.position.z + userData.depth / 2;
            if (rangeZ[0] > maxZ || rangeZ[1] < minZ) {
              isOnRangeZ = false;
            }
          }
          if (isOnRangeX && isOnRangeY && isOnRangeZ) {
            return true;
          }
        }
      });
    }
    function hideSection(section) {
      if (section !== null && section !== void 0 && section.length) {
        section.forEach(function (child) {
          setOpacity({
            child: child,
            newOpacity: 0
          });
        });
      }
    }
    function resetSection(section) {
      if (section !== null && section !== void 0 && section.length) {
        section.forEach(function (child) {
          resetOpacity({
            child: child
          });
        });
      }
    }
    var ar = {
      onRender: function onRender() {},
      initAR: function initAR() {
        var _threeJs$packages = threeJs.packages,
          packages = _threeJs$packages === void 0 ? {} : _threeJs$packages,
          arContainer = threeJs.arContainer;
        var AR = packages.AR;
        if (!ar.AR && AR && arContainer) {
          ar.AR = new AR({
            container: arContainer,
            onProgress: function onProgress(progress) {
              var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
              if (progress) {
                threeJs.showProgress({
                  message: message
                });
              } else {
                threeJs.hideProgress();
              }
            },
            onError: function onError(e) {
              if (e !== null && e !== void 0 && e.message) {
                threeJs.setSnackMessage(e.message);
              }
            },
            onUpdate: function () {
              var _onUpdate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee34(_ref54) {
                var faces, offsetWidth, offsetHeight, fov, _threeJs$currentCompo2, _threeJs$currentCompo3, _threeJs$currentCompo4, _threeJs$currentCompo5, _threeJs$currentCompo6, _threeJs$currentCompo7, width, height;
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee34$(_context34) {
                  while (1) switch (_context34.prev = _context34.next) {
                    case 0:
                      faces = _ref54.faces, offsetWidth = _ref54.offsetWidth, offsetHeight = _ref54.offsetHeight;
                      if (ar.AR.playState >= 1) {
                        fov = 45;
                        if (!onStart) {
                          init();
                          if (typeof tempFov == "undefined") {
                            tempFov = threeJs.camera.fov;
                          }
                          threeJs.camera.fov = fov;
                          threeJs.camera.position.x = 0;
                          threeJs.camera.position.y = 0;
                          threeJs.camera.position.z = 0;
                          threeJs.camera.zoom = 1;
                          threeJs.target.x = 0;
                          threeJs.target.y = 0;
                          threeJs.target.z = 0;
                          threeJs.camera.lookAt(threeJs.target.x, threeJs.target.y, threeJs.target.z);
                          threeJs.camera.updateProjectionMatrix();
                          threeJs.controls.enabled = false;
                          threeJs.controls.minPolarAngle = 0;
                          threeJs.controls.maxPolarAngle = Math.PI;
                          threeJs.controls.minAzimuthAngle = Infinity;
                          threeJs.controls.maxAzimuthAngle = Infinity;
                          if (typeof tempShowCalloutNotations !== "boolean") {
                            tempShowCalloutNotations = threeJs.showCalloutNotations;
                          }
                          if (typeof tempShowEditLines !== "boolean") {
                            tempShowEditLines = threeJs.showEditLines;
                          }
                          if (typeof tempShowShadowObjects !== "boolean") {
                            tempShowShadowObjects = threeJs.showShadowObjects;
                          }
                          threeJs.showCalloutNotations = false;
                          threeJs.showEditLines = false;
                          threeJs.showShadowObjects = false;
                          threeJs.setButtonsForControls();
                          if ((0, _toConsumableArray2["default"])(threeJs.scene.children).indexOf(cObject) === -1) {
                            threeJs.scene.add(cObject);
                          }
                          if ((0, _toConsumableArray2["default"])(threeJs.objects.children).indexOf(pObject) === -1) {
                            threeJs.objects.add(pObject);
                          }
                          if (!threeJs.world.boundingBox) {
                            threeJs.world.boundingBox = new THREE.Box3().setFromObject(threeJs.world);
                          }
                          boundingBox = (_threeJs$currentCompo2 = threeJs.currentComposition) !== null && _threeJs$currentCompo2 !== void 0 && (_threeJs$currentCompo3 = _threeJs$currentCompo2.ar) !== null && _threeJs$currentCompo3 !== void 0 && (_threeJs$currentCompo4 = _threeJs$currentCompo3.boundingBox) !== null && _threeJs$currentCompo4 !== void 0 && _threeJs$currentCompo4.max && (_threeJs$currentCompo5 = threeJs.currentComposition) !== null && _threeJs$currentCompo5 !== void 0 && (_threeJs$currentCompo6 = _threeJs$currentCompo5.ar) !== null && _threeJs$currentCompo6 !== void 0 && (_threeJs$currentCompo7 = _threeJs$currentCompo6.boundingBox) !== null && _threeJs$currentCompo7 !== void 0 && _threeJs$currentCompo7.min ? threeJs.currentComposition.ar.boundingBox : threeJs.world.boundingBox;
                          worldDepth = boundingBox.max.z - boundingBox.min.z;
                          worldWidth = boundingBox.max.x - boundingBox.min.x;
                          leftSection = selectObjects({
                            object: threeJs.objects,
                            rangeX: [0, worldWidth / 2],
                            rangeZ: [-worldDepth, 0]
                          });
                          rightSection = selectObjects({
                            object: threeJs.objects,
                            rangeX: [-worldWidth / 2, 0],
                            rangeZ: [-worldDepth, 0]
                          });
                          onStart = true;
                        }
                        width = offsetWidth;
                        height = offsetHeight;
                        ar.onRender = function () {
                          threeJs.camera.position.x = width / 2;
                          threeJs.camera.position.y = -height / 2;
                          threeJs.camera.position.z = -(height / 2) / Math.tan(fov / 2);
                          threeJs.target.x = width / 2;
                          threeJs.target.y = -height / 2;
                          threeJs.target.z = 0;
                          threeJs.camera.lookAt(threeJs.target.x, threeJs.target.y, threeJs.target.z);
                          var keypoints = faces && faces[0] && faces[0].keypoints || [];
                          if (keypoints.length) {
                            var center = {
                              x: keypoints[197].x + (keypoints[6].x - keypoints[197].x),
                              y: keypoints[197].y + (keypoints[6].y - keypoints[197].y),
                              z: keypoints[197].z + (keypoints[6].z - keypoints[197].z)
                            };
                            var noseBottom = keypoints[200];
                            var left = keypoints[454];
                            var right = keypoints[234];
                            if (isChanged(width / 200, [center, noseBottom, left, right])) {
                              var distance = new THREE.Vector3(left.x, left.y, left.z).distanceTo(new THREE.Vector3(right.x, right.y, right.z));
                              var scale = distance * 1.1 / worldWidth;
                              if (DEV) {
                                var ro = (0, _toConsumableArray2["default"])(keypoints);
                                var lastChildI = -1;
                                (0, _toConsumableArray2["default"])(testObject.children).forEach(function (o, i) {
                                  var roi = ro[i];
                                  if (roi) {
                                    lastChildI = i;
                                    o.position.set(roi.x, -roi.y, -(threeJs.camera.position.z * 0.25) + roi.z);
                                    if (roi === left || roi === right || roi === noseBottom) {
                                      o.material.color.setHex(0xff0000);
                                      o.scale.set(5, 5, 5);
                                    }
                                  }
                                });
                                if (testObject.children[lastChildI + 1]) {
                                  var _roi = center;
                                  var o = testObject.children[lastChildI + 1];
                                  if (_roi && o) {
                                    lastChildI = lastChildI + 1;
                                    o.position.set(_roi.x, -_roi.y, -(threeJs.camera.position.z * 0.25) + _roi.z);
                                    o.material.color.setHex(0xff0000);
                                    o.scale.set(5, 5, 5);
                                  }
                                }
                              }
                              threeJs.world.scale.set(scale, scale, scale);
                              var roi = center;
                              cObject.position.set(roi.x, -roi.y, -(threeJs.camera.position.z * 0.25) + roi.z);
                              threeJs.world.position.set(roi.x, -roi.y, -(threeJs.camera.position.z * 0.25) + roi.z + worldDepth / 2 * scale);
                              threeJs.objects.rotation.x = 0;
                              threeJs.objects.rotation.y = 0;
                              threeJs.objects.rotation.z = 0;
                              pObject.position.set(0, 0, worldDepth / 2);
                              threeJs.world.updateMatrixWorld(true);
                              cObject.updateMatrixWorld(true);
                              pObject.updateMatrixWorld(true);
                              var worldPositionBefore = new THREE.Vector3();
                              worldPositionBefore.setFromMatrixPosition(cObject.matrixWorld);
                              threeJs.world.rotation.y = Math.PI;
                              var uPDepth = left.z - right.z;
                              var uPWidth = left.x - right.x;
                              var uPRD = -Math.atan(uPDepth / uPWidth);
                              threeJs.objects.rotation.y = uPRD;
                              if (uPRD > Math.PI / 180 * 15) {
                                resetSection(rightSection);
                                hideSection(leftSection);
                              } else if (uPRD < Math.PI / 180 * -15) {
                                resetSection(leftSection);
                                hideSection(rightSection);
                              } else {
                                hideSection(leftSection);
                                hideSection(rightSection);
                              }
                              var fPHeight = center.y - noseBottom.y;
                              var fPWidth = center.x - noseBottom.x;
                              var fPRD = Math.atan(fPWidth / fPHeight);
                              threeJs.objects.rotation.z = -fPRD;
                              var sPHeight = center.y - noseBottom.y;
                              var sPDepth = center.z - noseBottom.z;
                              var sPRD = Math.atan(sPDepth / sPHeight);
                              threeJs.objects.rotation.x = /*(3 * Math.PI / 180) */sPRD;
                              threeJs.objects.updateMatrixWorld(true);
                              cObject.updateMatrixWorld(true);
                              pObject.updateMatrixWorld(true);
                              var worldPositionAfter = new THREE.Vector3();
                              worldPositionAfter.setFromMatrixPosition(pObject.matrixWorld);
                              var diff = new THREE.Vector3(worldPositionAfter.x - worldPositionBefore.x, worldPositionAfter.y - worldPositionBefore.y, worldPositionAfter.z - worldPositionBefore.z);
                              threeJs.world.position.set(threeJs.world.position.x - diff.x, threeJs.world.position.y - diff.y, threeJs.world.position.z - diff.z);
                              threeJs.objects.updateMatrixWorld(true);
                              cObject.updateMatrixWorld(true);
                              pObject.updateMatrixWorld(true);
                            }
                          }

                          /*const keypoints = faces && faces[0] && faces[0].keypoints || [];
                          if (keypoints.length) {
                               const contours = faceLandmarksDetection.util.getKeypointIndexByContour(
                                  faceLandmarksDetection.SupportedModels.MediaPipeFaceMesh);
                               for (const [label, contour] of Object.entries(contours)) {
                                  const path = contour.map((index) => keypoints[index]);
                                  if (path.every(value => value !== undefined)) {
                                      console.log(path)
                                  }
                              }
                           }*/
                        };
                      }
                    case 2:
                    case "end":
                      return _context34.stop();
                  }
                }, _callee34);
              }));
              function onUpdate(_x3) {
                return _onUpdate.apply(this, arguments);
              }
              return onUpdate;
            }()
          });
        }
      },
      toggleAR: function () {
        var _toggleAR = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee35() {
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee35$(_context35) {
            while (1) switch (_context35.prev = _context35.next) {
              case 0:
                if (!threeJs.splitScreen) {
                  _context35.next = 3;
                  break;
                }
                _context35.next = 3;
                return setSplitScreen(false);
              case 3:
                if (!ar.AR) {
                  ar.initAR();
                }
                if (!ar.AR) {
                  _context35.next = 11;
                  break;
                }
                _context35.next = 7;
                return ar.AR.toggle();
              case 7:
                if (ar.AR.playState <= 0) {
                  reset();
                }
                threeJs.setButtonsForControls();
                _context35.next = 13;
                break;
              case 11:
                console.log("[APP]", "AR:", "Error", "AR is not supported");
                threeJs.setSnackMessage("AR is not supported");
              case 13:
              case "end":
                return _context35.stop();
            }
          }, _callee35);
        }));
        function toggleAR() {
          return _toggleAR.apply(this, arguments);
        }
        return toggleAR;
      }(),
      startAR: function () {
        var _startAR = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee36() {
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee36$(_context36) {
            while (1) switch (_context36.prev = _context36.next) {
              case 0:
                if (!threeJs.splitScreen) {
                  _context36.next = 3;
                  break;
                }
                _context36.next = 3;
                return setSplitScreen(false);
              case 3:
                if (!ar.AR) {
                  ar.initAR();
                }
                if (!ar.AR) {
                  _context36.next = 10;
                  break;
                }
                _context36.next = 7;
                return ar.AR.start();
              case 7:
                threeJs.setButtonsForControls();
                _context36.next = 12;
                break;
              case 10:
                console.log("[APP]", "AR:", "Error", "AR is not supported");
                threeJs.setSnackMessage("AR is not supported");
              case 12:
              case "end":
                return _context36.stop();
            }
          }, _callee36);
        }));
        function startAR() {
          return _startAR.apply(this, arguments);
        }
        return startAR;
      }(),
      stopAR: function () {
        var _stopAR = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee37() {
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee37$(_context37) {
            while (1) switch (_context37.prev = _context37.next) {
              case 0:
                if (ar.AR) {
                  ar.AR.stop();
                } else {
                  console.log("[APP]", "AR:", "Error", "AR is not supported");
                  threeJs.setSnackMessage("AR is not supported");
                }
                reset();
                threeJs.setButtonsForControls();
              case 3:
              case "end":
                return _context37.stop();
            }
          }, _callee37);
        }));
        function stopAR() {
          return _stopAR.apply(this, arguments);
        }
        return stopAR;
      }()
    };
    return ar;
  }
  function threeJsObject() {
    var _artworkContext$data, _artworkContext$data$, _artworkContext$data2, _artworkContext$data3, _artworkContext$data4, _artworkContext$data5, _artworkContext$data6, _artworkContext$data7, _artworkContext$data8, _artworkContext$data9, _artworkContext$data10, _artworkContext$data11, _artworkContext$data12, _artworkContext$data13, _artworkContext$data14, _artworkContext$data15, _artworkContext$data16, _artworkContext$data17, _artworkContext$data18, _artworkContext$data19, _artworkContext$data20, _artworkContext$data21, _artworkContext$data22, _artworkContext$data23, _artworkContext$data24, _artworkContext$data25, _artworkContext$data26, _artworkContext$data27, _artworkContext$data28, _artworkContext$data29, _artworkContext$data30, _artworkContext$data31, _artworkContext$data32;
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var wapp = p.wapp,
      appContext = p.appContext,
      setCompositionIndex = p.setCompositionIndex,
      setSplitScreen = p.setSplitScreen,
      forceUpdate = p.forceUpdate,
      compositionIndex = p.compositionIndex,
      forceUpdateN = p.forceUpdateN,
      packages = p.packages,
      splitScreen = p.splitScreen,
      artworkContext = p.artworkContext,
      renderType = p.renderType,
      parentContainer = p.parentContainer,
      container = p.container,
      canvasBackgroundContainer = p.canvasBackgroundContainer,
      effects = p.effects,
      enableAnimation = p.enableAnimation,
      removeBackground = p.removeBackground,
      editor = p.editor,
      cameraZoom = p.cameraZoom,
      compositions = p.compositions,
      progressRef = p.progressRef,
      controlsRef = p.controlsRef,
      snackRef = p.snackRef,
      post = p.post;
    var rt = ((_artworkContext$data = artworkContext.data) === null || _artworkContext$data === void 0 ? void 0 : (_artworkContext$data$ = _artworkContext$data.renderProps) === null || _artworkContext$data$ === void 0 ? void 0 : _artworkContext$data$.renderType) || renderType || "SVG";
    var threeJs = {
      wapp: wapp,
      editor: editor,
      post: post,
      isGenerated: artworkContext.isGenerated,
      compositionIndex: compositionIndex,
      forceUpdateN: forceUpdateN,
      packages: packages,
      splitScreen: splitScreen,
      renderType: rt,
      parentContainer: parentContainer || container.current,
      canvasBackgroundContainer: canvasBackgroundContainer.current,
      effectsContainer: effects.current,
      fonts: {},
      version: ((_artworkContext$data2 = artworkContext.data) === null || _artworkContext$data2 === void 0 ? void 0 : (_artworkContext$data3 = _artworkContext$data2.renderProps) === null || _artworkContext$data3 === void 0 ? void 0 : _artworkContext$data3.version) || "1",
      lineProps: {
        opacity: typeof ((_artworkContext$data4 = artworkContext.data) === null || _artworkContext$data4 === void 0 ? void 0 : (_artworkContext$data5 = _artworkContext$data4.renderProps) === null || _artworkContext$data5 === void 0 ? void 0 : (_artworkContext$data6 = _artworkContext$data5.lineProps) === null || _artworkContext$data6 === void 0 ? void 0 : _artworkContext$data6.opacity) === "number" ? artworkContext.data.renderProps.lineProps.opacity : 0.4,
        color: ((_artworkContext$data7 = artworkContext.data) === null || _artworkContext$data7 === void 0 ? void 0 : (_artworkContext$data8 = _artworkContext$data7.renderProps) === null || _artworkContext$data8 === void 0 ? void 0 : (_artworkContext$data9 = _artworkContext$data8.lineProps) === null || _artworkContext$data9 === void 0 ? void 0 : _artworkContext$data9.color) || 0x000000,
        linewidth: typeof ((_artworkContext$data10 = artworkContext.data) === null || _artworkContext$data10 === void 0 ? void 0 : (_artworkContext$data11 = _artworkContext$data10.renderProps) === null || _artworkContext$data11 === void 0 ? void 0 : (_artworkContext$data12 = _artworkContext$data11.lineProps) === null || _artworkContext$data12 === void 0 ? void 0 : _artworkContext$data12.linewidth) === "number" ? artworkContext.data.renderProps.lineProps.linewidth : 1,
        disable: !!((_artworkContext$data13 = artworkContext.data) !== null && _artworkContext$data13 !== void 0 && (_artworkContext$data14 = _artworkContext$data13.renderProps) !== null && _artworkContext$data14 !== void 0 && (_artworkContext$data15 = _artworkContext$data14.lineProps) !== null && _artworkContext$data15 !== void 0 && _artworkContext$data15.disable) || false
      },
      composer: (_artworkContext$data16 = artworkContext.data) === null || _artworkContext$data16 === void 0 ? void 0 : (_artworkContext$data17 = _artworkContext$data16.renderProps) === null || _artworkContext$data17 === void 0 ? void 0 : _artworkContext$data17.composer,
      shadow: rt !== "SVG" && ((_artworkContext$data18 = artworkContext.data) === null || _artworkContext$data18 === void 0 ? void 0 : (_artworkContext$data19 = _artworkContext$data18.renderProps) === null || _artworkContext$data19 === void 0 ? void 0 : _artworkContext$data19.shadow),
      updateShadowMap: function updateShadowMap() {
        var _threeJs$shadow2;
        if ((_threeJs$shadow2 = threeJs.shadow) !== null && _threeJs$shadow2 !== void 0 && _threeJs$shadow2.enable) {
          var na = [0, 2, 3, 4];
          na.forEach(function (n) {
            var rendererPropName = n ? "renderer" + n : "renderer";
            if (threeJs[rendererPropName] && threeJs[rendererPropName].shadowMap) {
              threeJs[rendererPropName].shadowMap.needsUpdate = true;
            }
          });
        }
      },
      editLines: (_artworkContext$data20 = artworkContext.data) === null || _artworkContext$data20 === void 0 ? void 0 : (_artworkContext$data21 = _artworkContext$data20.renderProps) === null || _artworkContext$data21 === void 0 ? void 0 : _artworkContext$data21.editLines,
      showEditLines: true,
      toggleShowEditLines: function toggleShowEditLines() {
        var _threeJs$editLinesDat3;
        if ((_threeJs$editLinesDat3 = threeJs.editLinesData) !== null && _threeJs$editLinesDat3 !== void 0 && _threeJs$editLinesDat3.disableChangeEditLines) {
          return;
        }
        threeJs.showEditLines = !threeJs.showEditLines;
        if (!threeJs.enableAnimation && threeJs.render) {
          threeJs.render();
        }
      },
      calloutNotations: (_artworkContext$data22 = artworkContext.data) === null || _artworkContext$data22 === void 0 ? void 0 : (_artworkContext$data23 = _artworkContext$data22.renderProps) === null || _artworkContext$data23 === void 0 ? void 0 : _artworkContext$data23.calloutNotations,
      showCalloutNotations: true,
      toggleShowCalloutNotations: function toggleShowCalloutNotations() {
        var _threeJs$calloutNotat3;
        if ((_threeJs$calloutNotat3 = threeJs.calloutNotationsData) !== null && _threeJs$calloutNotat3 !== void 0 && _threeJs$calloutNotat3.disableChangeCalloutNotations) {
          return;
        }
        threeJs.showCalloutNotations = !threeJs.showCalloutNotations;
        if (!threeJs.enableAnimation && threeJs.render) {
          threeJs.render();
        }
      },
      showShadowObjects: true,
      enableAnimation: typeof enableAnimation === "boolean" ? enableAnimation : true,
      removeBackground: typeof removeBackground === "boolean" ? removeBackground : false,
      scene: null,
      camera: null,
      camera2: null,
      camera3: null,
      camera4: null,
      cameraD: typeof ((_artworkContext$data24 = artworkContext.data) === null || _artworkContext$data24 === void 0 ? void 0 : (_artworkContext$data25 = _artworkContext$data24.renderProps) === null || _artworkContext$data25 === void 0 ? void 0 : (_artworkContext$data26 = _artworkContext$data25.camera) === null || _artworkContext$data26 === void 0 ? void 0 : _artworkContext$data26.d) === "number" ? artworkContext.data.renderProps.camera.d : 35,
      cameraFov: typeof ((_artworkContext$data27 = artworkContext.data) === null || _artworkContext$data27 === void 0 ? void 0 : (_artworkContext$data28 = _artworkContext$data27.renderProps) === null || _artworkContext$data28 === void 0 ? void 0 : (_artworkContext$data29 = _artworkContext$data28.camera) === null || _artworkContext$data29 === void 0 ? void 0 : _artworkContext$data29.fov) === "number" ? artworkContext.data.renderProps.camera.fov : 45,
      cameraType: ((_artworkContext$data30 = artworkContext.data) === null || _artworkContext$data30 === void 0 ? void 0 : (_artworkContext$data31 = _artworkContext$data30.renderProps) === null || _artworkContext$data31 === void 0 ? void 0 : (_artworkContext$data32 = _artworkContext$data31.camera) === null || _artworkContext$data32 === void 0 ? void 0 : _artworkContext$data32.type) === "perspective" ? artworkContext.data.renderProps.camera.type : "orthographic",
      renderer: null,
      renderer2: null,
      renderer3: null,
      renderer4: null,
      reqId: null,
      removeInputListeners: null,
      controls: null,
      userCameraMoveing: null,
      removeControlListeners: null,
      objects: null,
      cameraIndex: 0,
      waitForControls: 0,
      render: null,
      selectObject: null,
      removeRayCasterInputForSelectListeners: null,
      pointer: new THREE.Vector2(0, 0),
      raycaster: new THREE.Raycaster(),
      animationControls: getAnimationControls({
        controlsRef: controlsRef
      }),
      runningTweens: [],
      waitForChangeSplitScreen: null,
      waitForChangeSplitScreenResolve: null,
      animationStop: function () {
        var _animationStop = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee38(p) {
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee38$(_context38) {
            while (1) switch (_context38.prev = _context38.next) {
              case 0:
                _context38.next = 2;
                return new Promise(function (resolve) {
                  threeJs.animationControls.waitForPause((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, p), {}, {
                    timeoutForControls: 0
                  }));
                  if (threeJs.runningAnimationResolve) {
                    console.log("[APP] Animation stopping...");
                    threeJs.runningAnimationResolve();
                  }
                  var sI = typeof window !== "undefined" && window.timeWeb ? window.timeWeb.o.setInterval : setInterval;
                  var cI = typeof window !== "undefined" && window.timeWeb ? window.timeWeb.o.clearInterval : clearInterval;
                  var _int3 = sI(function () {
                    function clearTweens() {
                      if (threeJs.runningTweens.length) {
                        var runningTweens = (0, _toConsumableArray2["default"])(threeJs.runningTweens);
                        runningTweens.forEach(function (tween) {
                          tween.end();
                          tween.stop();
                        });
                        threeJs.runningTweens = [];
                      }
                    }
                    if (!threeJs.animationControls) {
                      cI(_int3);
                      clearTweens();
                      resolve();
                      return;
                    }
                    if (threeJs.animationControls.isPaused()) {
                      threeJs.animationControls.pause(p);
                      cI(_int3);
                      clearTweens();
                      resolve();
                    }
                  }, 1);
                });
              case 2:
              case "end":
                return _context38.stop();
            }
          }, _callee38);
        }));
        function animationStop(_x4) {
          return _animationStop.apply(this, arguments);
        }
        return animationStop;
      }(),
      setSnackMessage: function () {
        var _setSnackMessage = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee39() {
          var _snackRef$current, _snackRef$current$act;
          var message,
            _args39 = arguments;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee39$(_context39) {
            while (1) switch (_context39.prev = _context39.next) {
              case 0:
                message = _args39.length > 0 && _args39[0] !== undefined ? _args39[0] : "";
                if (!(snackRef !== null && snackRef !== void 0 && (_snackRef$current = snackRef.current) !== null && _snackRef$current !== void 0 && (_snackRef$current$act = _snackRef$current.actions) !== null && _snackRef$current$act !== void 0 && _snackRef$current$act.setMessage)) {
                  _context39.next = 4;
                  break;
                }
                _context39.next = 4;
                return snackRef.current.actions.setMessage(message);
              case 4:
              case "end":
                return _context39.stop();
            }
          }, _callee39);
        }));
        function setSnackMessage() {
          return _setSnackMessage.apply(this, arguments);
        }
        return setSnackMessage;
      }(),
      showProgress: function () {
        var _showProgress = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee40() {
          var _progressRef$current, _progressRef$current$;
          var _ref55,
            _ref55$message,
            message,
            _args40 = arguments;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee40$(_context40) {
            while (1) switch (_context40.prev = _context40.next) {
              case 0:
                _ref55 = _args40.length > 0 && _args40[0] !== undefined ? _args40[0] : {}, _ref55$message = _ref55.message, message = _ref55$message === void 0 ? "" : _ref55$message;
                if (!(progressRef !== null && progressRef !== void 0 && (_progressRef$current = progressRef.current) !== null && _progressRef$current !== void 0 && (_progressRef$current$ = _progressRef$current.actions) !== null && _progressRef$current$ !== void 0 && _progressRef$current$.setShow)) {
                  _context40.next = 4;
                  break;
                }
                _context40.next = 4;
                return progressRef.current.actions.setShow({
                  message: message,
                  value: true
                });
              case 4:
              case "end":
                return _context40.stop();
            }
          }, _callee40);
        }));
        function showProgress() {
          return _showProgress.apply(this, arguments);
        }
        return showProgress;
      }(),
      hideProgress: function () {
        var _hideProgress = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee41() {
          var _progressRef$current2, _progressRef$current3;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee41$(_context41) {
            while (1) switch (_context41.prev = _context41.next) {
              case 0:
                if (!(progressRef !== null && progressRef !== void 0 && (_progressRef$current2 = progressRef.current) !== null && _progressRef$current2 !== void 0 && (_progressRef$current3 = _progressRef$current2.actions) !== null && _progressRef$current3 !== void 0 && _progressRef$current3.setShow)) {
                  _context41.next = 3;
                  break;
                }
                _context41.next = 3;
                return progressRef.current.actions.setShow({
                  message: "",
                  value: false
                });
              case 3:
              case "end":
                return _context41.stop();
            }
          }, _callee41);
        }));
        function hideProgress() {
          return _hideProgress.apply(this, arguments);
        }
        return hideProgress;
      }(),
      setControlsClickActions: function setControlsClickActions() {
        var _controlsRef$current2, _controlsRef$current3;
        if (controlsRef !== null && controlsRef !== void 0 && (_controlsRef$current2 = controlsRef.current) !== null && _controlsRef$current2 !== void 0 && (_controlsRef$current3 = _controlsRef$current2.actions) !== null && _controlsRef$current3 !== void 0 && _controlsRef$current3.setClickActions) {
          controlsRef.current.actions.setClickActions({
            onPlayClick: function () {
              var _onPlayClick = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee42(_ref56) {
                var playState, newIndex;
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee42$(_context42) {
                  while (1) switch (_context42.prev = _context42.next) {
                    case 0:
                      playState = _ref56.playState;
                      if (!(playState === 2)) {
                        _context42.next = 9;
                        break;
                      }
                      _context42.next = 4;
                      return threeJs.animationStop({
                        showControls: true
                      });
                    case 4:
                      threeJs.animationControls.play({
                        showControls: true,
                        timeoutForControls: 1000
                      });
                      newIndex = compositions[threeJs.compositionIndex + 1] ? threeJs.compositionIndex + 1 : 0;
                      if (threeJs.compositionIndex === newIndex) {
                        forceUpdate();
                      } else {
                        setCompositionIndex(newIndex);
                      }
                      _context42.next = 13;
                      break;
                    case 9:
                      if (!(playState === 0)) {
                        _context42.next = 13;
                        break;
                      }
                      _context42.next = 12;
                      return threeJs.animationStop({
                        showControls: true
                      });
                    case 12:
                      forceUpdate();
                    case 13:
                    case "end":
                      return _context42.stop();
                  }
                }, _callee42);
              }));
              function onPlayClick(_x5) {
                return _onPlayClick.apply(this, arguments);
              }
              return onPlayClick;
            }(),
            onDotClick: function () {
              var _onDotClick = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee43(_ref57) {
                var compositionIndex, newIndex;
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee43$(_context43) {
                  while (1) switch (_context43.prev = _context43.next) {
                    case 0:
                      compositionIndex = _ref57.compositionIndex;
                      if (!threeJs.animationControls.isPaused()) {
                        _context43.next = 6;
                        break;
                      }
                      newIndex = compositionIndex > threeJs.compositionIndex ? compositions[compositionIndex] ? compositionIndex : 0 : compositions[compositionIndex] ? compositionIndex : compositions.length - 1;
                      setCompositionIndex(newIndex);
                      _context43.next = 9;
                      break;
                    case 6:
                      if (!threeJs.animationControls.isPlaying()) {
                        _context43.next = 9;
                        break;
                      }
                      _context43.next = 9;
                      return threeJs.animationStop({
                        showControls: true
                      });
                    case 9:
                    case "end":
                      return _context43.stop();
                  }
                }, _callee43);
              }));
              function onDotClick(_x6) {
                return _onDotClick.apply(this, arguments);
              }
              return onDotClick;
            }(),
            camera: function () {
              var _camera = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee44() {
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee44$(_context44) {
                  while (1) switch (_context44.prev = _context44.next) {
                    case 0:
                      _context44.next = 2;
                      return cameraMoveByControls(threeJs, "center", 900);
                    case 2:
                    case "end":
                      return _context44.stop();
                  }
                }, _callee44);
              }));
              function camera() {
                return _camera.apply(this, arguments);
              }
              return camera;
            }(),
            splitScreen: function () {
              var _splitScreen = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee45(_ref58) {
                var _threeJs$splitScreenD42;
                var value;
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee45$(_context45) {
                  while (1) switch (_context45.prev = _context45.next) {
                    case 0:
                      value = _ref58.value;
                      if (!((_threeJs$splitScreenD42 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD42 !== void 0 && _threeJs$splitScreenD42.disableChangeSplitScreen)) {
                        _context45.next = 3;
                        break;
                      }
                      return _context45.abrupt("return");
                    case 3:
                      if (!threeJs.animationControls.isPaused()) {
                        _context45.next = 8;
                        break;
                      }
                      _context45.next = 6;
                      return setSplitScreen(value);
                    case 6:
                      _context45.next = 13;
                      break;
                    case 8:
                      if (!threeJs.animationControls.isPlaying()) {
                        _context45.next = 13;
                        break;
                      }
                      _context45.next = 11;
                      return threeJs.animationStop({
                        showControls: true
                      });
                    case 11:
                      _context45.next = 13;
                      return threeJs.setButtonsForControls();
                    case 13:
                    case "end":
                      return _context45.stop();
                  }
                }, _callee45);
              }));
              function splitScreen(_x7) {
                return _splitScreen.apply(this, arguments);
              }
              return splitScreen;
            }(),
            calloutNotations: function () {
              var _calloutNotations = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee46(_ref59) {
                var _threeJs$calloutNotat4;
                var value;
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee46$(_context46) {
                  while (1) switch (_context46.prev = _context46.next) {
                    case 0:
                      value = _ref59.value;
                      if (!((_threeJs$calloutNotat4 = threeJs.calloutNotationsData) !== null && _threeJs$calloutNotat4 !== void 0 && _threeJs$calloutNotat4.disableChangeCalloutNotations)) {
                        _context46.next = 3;
                        break;
                      }
                      return _context46.abrupt("return");
                    case 3:
                      if (!threeJs.animationControls.isPaused()) {
                        _context46.next = 8;
                        break;
                      }
                      threeJs.showCalloutNotations = value;
                      if (!threeJs.enableAnimation && threeJs.render) {
                        threeJs.render();
                      }
                      _context46.next = 10;
                      break;
                    case 8:
                      _context46.next = 10;
                      return threeJs.animationStop({
                        showControls: true
                      });
                    case 10:
                    case "end":
                      return _context46.stop();
                  }
                }, _callee46);
              }));
              function calloutNotations(_x8) {
                return _calloutNotations.apply(this, arguments);
              }
              return calloutNotations;
            }(),
            editLines: function () {
              var _editLines = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee47(_ref60) {
                var _threeJs$editLinesDat4;
                var value;
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee47$(_context47) {
                  while (1) switch (_context47.prev = _context47.next) {
                    case 0:
                      value = _ref60.value;
                      if (!((_threeJs$editLinesDat4 = threeJs.editLinesData) !== null && _threeJs$editLinesDat4 !== void 0 && _threeJs$editLinesDat4.disableChangeEditLines)) {
                        _context47.next = 3;
                        break;
                      }
                      return _context47.abrupt("return");
                    case 3:
                      if (!threeJs.animationControls.isPaused()) {
                        _context47.next = 8;
                        break;
                      }
                      threeJs.showEditLines = value;
                      if (!threeJs.enableAnimation && threeJs.render) {
                        threeJs.render();
                      }
                      _context47.next = 10;
                      break;
                    case 8:
                      _context47.next = 10;
                      return threeJs.animationStop({
                        showControls: true
                      });
                    case 10:
                    case "end":
                      return _context47.stop();
                  }
                }, _callee47);
              }));
              function editLines(_x9) {
                return _editLines.apply(this, arguments);
              }
              return editLines;
            }(),
            save: function () {
              var _save = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee48(_ref61) {
                var e, value, dimension;
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee48$(_context48) {
                  while (1) switch (_context48.prev = _context48.next) {
                    case 0:
                      e = _ref61.e, value = _ref61.value;
                      if (!(value === "open")) {
                        _context48.next = 9;
                        break;
                      }
                      if (!threeJs.animationControls.isPaused()) {
                        _context48.next = 5;
                        break;
                      }
                      _context48.next = 7;
                      break;
                    case 5:
                      _context48.next = 7;
                      return threeJs.animationStop({
                        showControls: true
                      });
                    case 7:
                      _context48.next = 13;
                      break;
                    case 9:
                      dimension = threeJs.dimensions[value];
                      e.preventDefault();
                      e.stopPropagation();
                      threeJs.save(dimension);
                    case 13:
                    case "end":
                      return _context48.stop();
                  }
                }, _callee48);
              }));
              function save(_x10) {
                return _save.apply(this, arguments);
              }
              return save;
            }(),
            ar: function () {
              var _ar = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee49(_ref62) {
                var value;
                return (0, _regeneratorRuntime2["default"])().wrap(function _callee49$(_context49) {
                  while (1) switch (_context49.prev = _context49.next) {
                    case 0:
                      value = _ref62.value;
                      if (!threeJs.animationControls.isPaused()) {
                        _context49.next = 11;
                        break;
                      }
                      if (!value) {
                        _context49.next = 7;
                        break;
                      }
                      _context49.next = 5;
                      return threeJs.ar.startAR();
                    case 5:
                      _context49.next = 9;
                      break;
                    case 7:
                      _context49.next = 9;
                      return threeJs.ar.stopAR();
                    case 9:
                      _context49.next = 13;
                      break;
                    case 11:
                      _context49.next = 13;
                      return threeJs.animationStop({
                        showControls: true
                      });
                    case 13:
                    case "end":
                      return _context49.stop();
                  }
                }, _callee49);
              }));
              function ar(_x11) {
                return _ar.apply(this, arguments);
              }
              return ar;
            }()
          });
        }
      },
      setDotsForControls: function () {
        var _setDotsForControls = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee50(p) {
          var _controlsRef$current4, _controlsRef$current5;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee50$(_context50) {
            while (1) switch (_context50.prev = _context50.next) {
              case 0:
                if (!(controlsRef !== null && controlsRef !== void 0 && (_controlsRef$current4 = controlsRef.current) !== null && _controlsRef$current4 !== void 0 && (_controlsRef$current5 = _controlsRef$current4.actions) !== null && _controlsRef$current5 !== void 0 && _controlsRef$current5.setDots)) {
                  _context50.next = 3;
                  break;
                }
                _context50.next = 3;
                return controlsRef.current.actions.setDots(p);
              case 3:
              case "end":
                return _context50.stop();
            }
          }, _callee50);
        }));
        function setDotsForControls(_x12) {
          return _setDotsForControls.apply(this, arguments);
        }
        return setDotsForControls;
      }(),
      showControls: function () {
        var _showControls3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee51() {
          var _controlsRef$current6, _controlsRef$current7;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee51$(_context51) {
            while (1) switch (_context51.prev = _context51.next) {
              case 0:
                if (!(controlsRef !== null && controlsRef !== void 0 && (_controlsRef$current6 = controlsRef.current) !== null && _controlsRef$current6 !== void 0 && (_controlsRef$current7 = _controlsRef$current6.actions) !== null && _controlsRef$current7 !== void 0 && _controlsRef$current7.setState)) {
                  _context51.next = 3;
                  break;
                }
                _context51.next = 3;
                return controlsRef.current.actions.setState({
                  show: true
                });
              case 3:
              case "end":
                return _context51.stop();
            }
          }, _callee51);
        }));
        function showControls() {
          return _showControls3.apply(this, arguments);
        }
        return showControls;
      }(),
      toggleShowControls: function () {
        var _toggleShowControls = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee52() {
          var _controlsRef$current8, _controlsRef$current9;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee52$(_context52) {
            while (1) switch (_context52.prev = _context52.next) {
              case 0:
                if (!(controlsRef !== null && controlsRef !== void 0 && (_controlsRef$current8 = controlsRef.current) !== null && _controlsRef$current8 !== void 0 && (_controlsRef$current9 = _controlsRef$current8.actions) !== null && _controlsRef$current9 !== void 0 && _controlsRef$current9.toggleShow)) {
                  _context52.next = 3;
                  break;
                }
                _context52.next = 3;
                return controlsRef.current.actions.toggleShow();
              case 3:
              case "end":
                return _context52.stop();
            }
          }, _callee52);
        }));
        function toggleShowControls() {
          return _toggleShowControls.apply(this, arguments);
        }
        return toggleShowControls;
      }(),
      getControlsShow: function getControlsShow() {
        var _controlsRef$current10, _controlsRef$current11;
        if (controlsRef !== null && controlsRef !== void 0 && (_controlsRef$current10 = controlsRef.current) !== null && _controlsRef$current10 !== void 0 && (_controlsRef$current11 = _controlsRef$current10.actions) !== null && _controlsRef$current11 !== void 0 && _controlsRef$current11.getShow) {
          return controlsRef.current.actions.getShow();
        }
      },
      enableControlsPlayButton: function () {
        var _enableControlsPlayButton = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee53() {
          var _controlsRef$current12, _controlsRef$current13;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee53$(_context53) {
            while (1) switch (_context53.prev = _context53.next) {
              case 0:
                if (!(controlsRef !== null && controlsRef !== void 0 && (_controlsRef$current12 = controlsRef.current) !== null && _controlsRef$current12 !== void 0 && (_controlsRef$current13 = _controlsRef$current12.actions) !== null && _controlsRef$current13 !== void 0 && _controlsRef$current13.setEnablePlayButton)) {
                  _context53.next = 3;
                  break;
                }
                _context53.next = 3;
                return controlsRef.current.actions.setEnablePlayButton(true);
              case 3:
              case "end":
                return _context53.stop();
            }
          }, _callee53);
        }));
        function enableControlsPlayButton() {
          return _enableControlsPlayButton.apply(this, arguments);
        }
        return enableControlsPlayButton;
      }(),
      setButtonsForControls: function () {
        var _setButtonsForControls = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee54() {
          var _controlsRef$current14, _controlsRef$current15;
          var _threeJs$ar7, _threeJs$ar7$AR, _threeJs$currentCompo8, _threeJs$packages2, _threeJs$ar8, _threeJs$ar8$AR, _threeJs$splitScreenD43, _threeJs$editLines, _threeJs$editLinesDat5, _threeJs$calloutNotat5, _threeJs$calloutNotat6, getSaveName, dimKeys, arIsRunning;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee54$(_context54) {
            while (1) switch (_context54.prev = _context54.next) {
              case 0:
                if (!(controlsRef !== null && controlsRef !== void 0 && (_controlsRef$current14 = controlsRef.current) !== null && _controlsRef$current14 !== void 0 && (_controlsRef$current15 = _controlsRef$current14.actions) !== null && _controlsRef$current15 !== void 0 && _controlsRef$current15.setButtons)) {
                  _context54.next = 8;
                  break;
                }
                getSaveName = function getSaveName(dimension) {
                  return [].concat((0, _toConsumableArray2["default"])(dimension.name ? [dimension.name] : []), ["[" + dimension.width + "x" + dimension.height + "]"]).join(" ");
                };
                dimKeys = Object.keys(threeJs.dimensions);
                arIsRunning = ((_threeJs$ar7 = threeJs.ar) === null || _threeJs$ar7 === void 0 ? void 0 : (_threeJs$ar7$AR = _threeJs$ar7.AR) === null || _threeJs$ar7$AR === void 0 ? void 0 : _threeJs$ar7$AR.playState) >= 1;
                _context54.next = 6;
                return controlsRef.current.actions.setAdditionalProps({
                  arIsRunning: arIsRunning
                });
              case 6:
                _context54.next = 8;
                return controlsRef.current.actions.setButtons({
                  buttons: [].concat((0, _toConsumableArray2["default"])((_threeJs$currentCompo8 = threeJs.currentComposition.ar) !== null && _threeJs$currentCompo8 !== void 0 && _threeJs$currentCompo8.enable && (_threeJs$packages2 = threeJs.packages) !== null && _threeJs$packages2 !== void 0 && _threeJs$packages2.AR ? [{
                    key: "ar",
                    value: ((_threeJs$ar8 = threeJs.ar) === null || _threeJs$ar8 === void 0 ? void 0 : (_threeJs$ar8$AR = _threeJs$ar8.AR) === null || _threeJs$ar8$AR === void 0 ? void 0 : _threeJs$ar8$AR.playState) >= 1
                  }] : []), (0, _toConsumableArray2["default"])(!((_threeJs$splitScreenD43 = threeJs.splitScreenData) !== null && _threeJs$splitScreenD43 !== void 0 && _threeJs$splitScreenD43.disableChangeSplitScreen) ? [{
                    key: "splitScreen",
                    value: threeJs.splitScreen,
                    disabled: arIsRunning
                  }] : []), [{
                    key: "save",
                    value: false,
                    disabled: arIsRunning,
                    items: [].concat((0, _toConsumableArray2["default"])(threeJs.defaultDimension && threeJs.dimensions[threeJs.defaultDimension] ? [{
                      name: getSaveName(threeJs.dimensions[threeJs.defaultDimension]),
                      props: {
                        itemTextProps: {
                          secondary: appContext.labels.defaultAspectRatio
                        }
                      },
                      key: ""
                    }] : []), [{
                      divider: true
                    }], (0, _toConsumableArray2["default"])(dimKeys.filter(function (key) {
                      return threeJs.dimensions[key] && threeJs.dimensions[key].width && threeJs.dimensions[key].height && threeJs.defaultDimension !== key;
                    }).map(function (key) {
                      return {
                        name: getSaveName(threeJs.dimensions[key]),
                        key: key
                      };
                    })))
                  }, {
                    key: "camera",
                    value: false,
                    oneStateButton: true,
                    disabled: arIsRunning
                  }], (0, _toConsumableArray2["default"])((_threeJs$editLines = threeJs.editLines) !== null && _threeJs$editLines !== void 0 && _threeJs$editLines.enable && !((_threeJs$editLinesDat5 = threeJs.editLinesData) !== null && _threeJs$editLinesDat5 !== void 0 && _threeJs$editLinesDat5.disableChangeEditLines) ? [{
                    key: "editLines",
                    value: threeJs.showEditLines,
                    disabled: arIsRunning
                  }] : []), (0, _toConsumableArray2["default"])((_threeJs$calloutNotat5 = threeJs.calloutNotations) !== null && _threeJs$calloutNotat5 !== void 0 && _threeJs$calloutNotat5.enable && !((_threeJs$calloutNotat6 = threeJs.calloutNotationsData) !== null && _threeJs$calloutNotat6 !== void 0 && _threeJs$calloutNotat6.disableChangeCalloutNotations) ? [{
                    key: "calloutNotations",
                    value: threeJs.showCalloutNotations,
                    disabled: arIsRunning
                  }] : []))
                });
              case 8:
              case "end":
                return _context54.stop();
            }
          }, _callee54);
        }));
        function setButtonsForControls() {
          return _setButtonsForControls.apply(this, arguments);
        }
        return setButtonsForControls;
      }(),
      exporter: function () {
        var _exporter = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee56(type) {
          var _threeJs$post, _threeJs$post2, _threeJs$post3;
          var splitScreen, tempShowEditLines, currentComposition, tempEnableAnimation, tempResizeFunction, group, needToRemove, children, groups, enabledGroups, showChildren, scene, fileName, saveFile, _exporter2, parse, blob, _exporter3, _exporter4;
          return (0, _regeneratorRuntime2["default"])().wrap(function _callee56$(_context56) {
            while (1) switch (_context56.prev = _context56.next) {
              case 0:
                saveFile = function _saveFile(fileNameEnd, blob) {
                  var downloadLink = document.createElement("a");
                  downloadLink.download = fileName + fileNameEnd;
                  downloadLink.href = URL.createObjectURL(blob);
                  document.body.appendChild(downloadLink);
                  downloadLink.click();
                  document.body.removeChild(downloadLink);
                };
                splitScreen = threeJs.splitScreen;
                console.log("[APP]", "Saving...");
                threeJs.saveIsProgress = true;
                tempShowEditLines = threeJs.showEditLines;
                threeJs.showEditLines = false;
                _context56.next = 8;
                return threeJs.showProgress({
                  message: "Saving..."
                });
              case 8:
                _context56.next = 10;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 200);
                });
              case 10:
                currentComposition = threeJs.currentComposition;
                _context56.next = 13;
                return threeJs.showProgress({
                  message: "Animation stopping..."
                });
              case 13:
                _context56.next = 15;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 15:
                _context56.next = 17;
                return threeJs.animationStop({
                  showControls: false
                });
              case 17:
                tempEnableAnimation = threeJs.enableAnimation;
                threeJs.enableAnimation = false;
                _context56.next = 21;
                return threeJs.showProgress({
                  message: "Canvas resizing..."
                });
              case 21:
                _context56.next = 23;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 23:
                tempResizeFunction = threeJs.onResize;
                threeJs.onResize = function () {};
                _context56.next = 27;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 27:
                tempResizeFunction();
                _context56.next = 30;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 30:
                _context56.next = 32;
                return threeJs.showProgress({
                  message: "Collecting file..."
                });
              case 32:
                _context56.next = 34;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 34:
                group = threeJs.objects.clone();
                needToRemove = [];
                children = (0, _toConsumableArray2["default"])(group.children);
                children.forEach(function (child) {
                  var c = (0, _toConsumableArray2["default"])(child.children);
                  needToRemove.push.apply(needToRemove, (0, _toConsumableArray2["default"])(c.slice(1)));
                  if (child.userData.data.material.opacity === 0) {
                    needToRemove.push(child);
                  }
                });
                needToRemove.forEach(function (mesh) {
                  mesh.removeFromParent();
                });
                group.scale.set(1, 1, 1);
                group.position.set(0, 0, 0);
                group.rotation.set(0, 0, 0);
                group.updateMatrixWorld(true);
                groups = {};
                enabledGroups = currentComposition.groups ? Object.keys(currentComposition.groups).filter(function (groupName) {
                  return currentComposition.groups[groupName] && currentComposition.groups[groupName].enable;
                }) : [];
                showChildren = (0, _toConsumableArray2["default"])(group.children);
                showChildren.forEach(function (child) {
                  var childGroup = child.userData.data.group;
                  if (childGroup && enabledGroups.indexOf(childGroup) > -1) {
                    if (!groups[childGroup]) {
                      groups[childGroup] = new THREE.Object3D();
                    }
                    child.removeFromParent();
                    groups[childGroup].add(child);
                  }
                });
                scene = new THREE.Object3D();
                if ((0, _toConsumableArray2["default"])(group.children).length) {
                  scene.add(group);
                }
                Object.keys(groups).forEach(function (groupName) {
                  scene.add(groups[groupName]);
                });
                fileName = ["c4rc0", ((_threeJs$post = threeJs.post) === null || _threeJs$post === void 0 ? void 0 : _threeJs$post.slug) || ((_threeJs$post2 = threeJs.post) === null || _threeJs$post2 === void 0 ? void 0 : _threeJs$post2._id) || "", threeJs.isGenerated && (_threeJs$post3 = threeJs.post) !== null && _threeJs$post3 !== void 0 && _threeJs$post3.hash && threeJs.post.hash !== threeJs.post.slug ? threeJs.post.hash : "", "composition", threeJs.compositionIndex, splitScreen ? "splitscreen" : ""].filter(function (t) {
                  return t || t === 0;
                }).join("_");
                if (!(packages.GLTFExporter && type === "gltf")) {
                  _context56.next = 58;
                  break;
                }
                _exporter2 = new packages.GLTFExporter();
                parse = /*#__PURE__*/function () {
                  var _ref63 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/(0, _regeneratorRuntime2["default"])().mark(function _callee55(scene, options) {
                    var result, output;
                    return (0, _regeneratorRuntime2["default"])().wrap(function _callee55$(_context55) {
                      while (1) switch (_context55.prev = _context55.next) {
                        case 0:
                          _context55.next = 2;
                          return new Promise(function (resolve, reject) {
                            _exporter2.parse(scene, function (gltf) {
                              result = gltf;
                              resolve(result);
                            }, function (error) {
                              reject(error);
                            }, (0, _objectSpread2["default"])({}, options ? options : {}));
                          });
                        case 2:
                          if (!(result instanceof ArrayBuffer)) {
                            _context55.next = 6;
                            break;
                          }
                          return _context55.abrupt("return", new Blob([result], {
                            type: 'application/octet-stream'
                          }));
                        case 6:
                          output = JSON.stringify(result, null, 2);
                          return _context55.abrupt("return", new Blob([output], {
                            type: "text/plain;charset=utf-8"
                          }));
                        case 8:
                        case "end":
                          return _context55.stop();
                      }
                    }, _callee55);
                  }));
                  return function parse(_x14, _x15) {
                    return _ref63.apply(this, arguments);
                  };
                }();
                _context56.next = 56;
                return parse((0, _toConsumableArray2["default"])(scene.children));
              case 56:
                blob = _context56.sent;
                if (blob) {
                  saveFile("_all.gltf", blob);
                }
              case 58:
                if (packages.OBJExporter && type === "obj") {
                  _exporter3 = new packages.OBJExporter();
                  saveFile("_all.obj", new Blob([_exporter3.parse(scene)], {
                    type: "text/plain;charset=utf-8"
                  }));
                  Object.keys(groups).forEach(function (groupName) {
                    var group = groups[groupName];
                    saveFile("_" + groupName + ".obj", new Blob([_exporter3.parse(group)], {
                      type: "text/plain;charset=utf-8"
                    }));
                  });
                }
                if (packages.STLExporter && type === "stl") {
                  _exporter4 = new packages.STLExporter();
                  saveFile("_all.stl", new Blob([_exporter4.parse(scene)], {
                    type: "text/plain;charset=utf-8"
                  }));
                  Object.keys(groups).forEach(function (groupName) {
                    var group = groups[groupName];
                    saveFile("_" + groupName + ".stl", new Blob([_exporter4.parse(group)], {
                      type: "text/plain;charset=utf-8"
                    }));
                  });
                }
                _context56.next = 62;
                return threeJs.showProgress({
                  message: "Canvas resizing..."
                });
              case 62:
                _context56.next = 64;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 64:
                tempResizeFunction();
                _context56.next = 67;
                return threeJs.showProgress({
                  message: "Animation starting..."
                });
              case 67:
                _context56.next = 69;
                return new Promise(function (resolve) {
                  return setTimeout(resolve, 100);
                });
              case 69:
                if (tempEnableAnimation) {
                  threeJs.enableAnimation = true;
                }
                if (typeof tempShowEditLines == "boolean") {
                  threeJs.showEditLines = tempShowEditLines;
                }
                if (threeJs.render) {
                  threeJs.render();
                }
                threeJs.onResize = tempResizeFunction;
                threeJs.hideProgress();
                threeJs.saveIsProgress = false;
              case 75:
              case "end":
                return _context56.stop();
            }
          }, _callee56);
        }));
        function exporter(_x13) {
          return _exporter.apply(this, arguments);
        }
        return exporter;
      }(),
      canvasTextRenderer: function canvasTextRenderer() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        return (0, _canvasTextRenderer2["default"])((0, _objectSpread2["default"])({
          threeJs: threeJs
        }, props));
      }
    };
    threeJs.ar = getARFunctions({
      threeJs: threeJs,
      editor: editor,
      setSplitScreen: setSplitScreen
    });
    addDimFunctions({
      threeJs: threeJs
    });
    addSaveFunction({
      threeJs: threeJs
    });
    threeJs.last = {};
    threeJs.currentComposition = compositions[compositionIndex];
    updateThreeJsObject({
      threeJs: threeJs,
      editor: editor,
      cameraZoom: cameraZoom
    });
    return threeJs;
  }
  function getInitialCompositions() {
    var _artworkContext$data33, _artworkContext$data34;
    var p = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var artworkContext = p.artworkContext,
      generateCompositions = p.generateCompositions,
      externalSettings = p.externalSettings,
      generateRenderProps = p.generateRenderProps;
    if (!((_artworkContext$data33 = artworkContext.data) !== null && _artworkContext$data33 !== void 0 && _artworkContext$data33.compositions) || (_artworkContext$data34 = artworkContext.data) !== null && _artworkContext$data34 !== void 0 && _artworkContext$data34.compositions && !artworkContext.data.compositions[0]) {
      artworkContext.isGenerated = true;
      if (!artworkContext.data) {
        artworkContext.data = {};
      }
      var generateProps = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({
        generateType: externalSettings.generateType
      }, params ? params : {}), {}, {
        hash: externalSettings.hash
      });
      artworkContext.data.compositions = externalSettings.compositions || generateCompositions(generateProps).compositions;
      if (!artworkContext.data.renderProps) {
        artworkContext.data.renderProps = {};
      }
      var renderPropsFromExternalOrGenerated = externalSettings.renderProps || generateRenderProps(generateProps) || {};
      Object.keys(renderPropsFromExternalOrGenerated).forEach(function (key) {
        if (typeof renderPropsFromExternalOrGenerated[key] === "object") {
          if (!artworkContext.data.renderProps[key]) {
            artworkContext.data.renderProps[key] = {};
          }
          artworkContext.data.renderProps[key] = (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, renderPropsFromExternalOrGenerated[key]), artworkContext.data.renderProps[key] ? artworkContext.data.renderProps[key] : {});
        } else {
          artworkContext.data.renderProps[key] = artworkContext.data.renderProps[key] || renderPropsFromExternalOrGenerated[key];
        }
      });
    }
    return artworkContext.data.compositions;
  }
  return {
    generateCompositions: generateCompositions,
    generateRenderProps: generateRenderProps,
    selectObject: selectObject,
    updateComposition: updateComposition,
    onKeyDown: onKeyDown,
    cameraMoveByControls: cameraMoveByControls,
    init: init,
    updateRenderers: updateRenderers,
    threeJsObject: threeJsObject,
    getInitialCompositions: getInitialCompositions
  };
}